/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-use-before-define */
import useCommon from '@utils/hooks/common';
import {Button, Descriptions, Modal, notification, Spin, Statistic} from 'antd';
import {isEqual, omit, get} from 'lodash-es';
import {GameLogicInterface, GameRoomInterface} from 'poker-interfaces';
import Router, {useRouter} from 'next/router';
import {useMediaQuery} from 'react-responsive';
import {TABLET_BREAKPOINT} from '@constant/system';
import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useImperativeHandle,
  useCallback,
  useContext,
} from 'react';
import BigNumber from 'bignumber.js';
import TableAreaMobile from '@components/game-room/TableAreaMobile';
import {
  GAME_EVENTS,
  COLOR_THEME,
  getGameEventV2,
  TABLE_UPDATE_DELAY,
  COLLECT_CHIP_DELAY,
  getGameEventV3,
  TABLE_ACTIONS,
  ROOM_ACTION,
  SUIT,
  ButtonLoadingState,
  PLAYER_ACTION,
  CHIP_TRANSITION_DURATION,
  CHIP_MOVING_DURATION,
  COMMUNITY_CARD_PRE_FLOP_FLIP_DELAY,
  COMMUNITY_CARD_POST_FLOP_FLIP_DELAY,
} from '@constant/game';
import ActionButtons from '@components/game-room/ActionButtons';
import ChatRoom from '@components/chat-room';
import {
  BestCombination,
  GameResultOnScreen,
  EmojiContextInterface,
  EmojiStatus,
  EmojiIdentifier,
  GameRoomComponent,
  Notification,
  PokerComponent,
  PlayerComponent,
  ComponentsPositions,
  PositionContextInterface,
  TabBubble,
  AbsolutePosition,
  TabBubbleHandVisibleContextInterface,
} from '@interface';
import styles from './styles';
import {ClockCircleOutlined, Loading3QuartersOutlined} from '@ant-design/icons';
import {useDebugView} from '@utils/hooks/debug';
import BuyInModal from '@components/game-room/BuyInModal';
import WaitList from '@components/game-room/WaitList';
import EmojiDrawer from '@components/game-room/EmojiDrawer';
import emojiButtonIcon from '@public/images-mobile/game-room/emoji-button.svg';
import {useCurrencyId, useGameMode} from '@utils/hooks/gameSettings';
import {
  mockPlayer,
  mockCard,
  mockCommunityCard,
  mockInsuranceInfo,
  mockResult,
  mockRoomInfo,
  mockTableInfo,
  mockPlayersOmaha,
  getMockResult,
  getMockTableInfo,
} from 'test/mock';

import {env} from 'next-runtime-env';
import dynamic from 'next/dynamic';
import {
  EmojiContext,
  PositionContext,
  ResizeLoadingContext,
  TabBubbleHandVisibleContext,
  TournamentContext,
  TournamentContextInterface,
} from '@utils/context';
import classNames from 'classnames';
import {usePrevious, useRequest, useWhyDidYouUpdate} from 'ahooks';
import gameApi from '@utils/api/game.api';
import diamondItemsApi from '@utils/api/diamondItems';
import playerItemApi from '@utils/api/playerItem.api';
import {
  BestCombinationResult,
  GameResultResponse,
  GameRoomGeneralResponse,
  PrivateInfoResponse,
  SitOutResponse,
} from 'poker-interfaces/game-room/game-room-interface';
import ExtendTimer from '../ExtendTimer';
import {copyTextToClipboard, getPlayerCurrentMoney, getSafe, pause} from '@utils/index';
import {LoadingOutlined} from '@ant-design/icons';
import HistoryDrawer from '../HistoryDrawer';
import {AutoAction, Player} from 'poker-interfaces/gameLogic/gameLogicInterface';
// TODO @@ private-room
import BuyInModalSheet from '../BuyInModalSheet';
import CustomPopup from '@components/CustomPopup';
import GradientButton from '@components/GradientButton';
import {AnimatePresence, motion} from 'framer-motion';
import CanvasArea from './CanvasArea';
import CustomModalSheet from '@components/CustomModalSheet';
import {DescriptionsItemType} from 'antd/es/descriptions';
import dayjs from 'dayjs';
import TournamentResultModalSheet from '@components/tournament/TournamentResultModalSheet';
import ContinueIcon from '@public/icon/game-room/continue.svg';
import Countdown, {zeroPad} from 'react-countdown';
import TournamentReEntryModalSheet from '@components/tournament/TournamentReEntryModalSheet';
import TournamentThanksForJoiningModalSheet from '@components/tournament/TournamentThanksForJoiningModalSheet';
import TournamentCancelModalSheet from '@components/tournament/TournamentCancelModalSheet';
import TournamentWaitingForPlayersModalSheet from '@components/tournament/TournamentWaitingForPlayersModalSheet';

enum DropdownItems {
  LEAVE_GAME,
  LEAVE_TABLE,
}
enum RoomMessage {
  SHARE_LINK,
  COPY_ROOM_CODE,
}

interface GameResultHandlerType {
  result: GameResultResponse['result'];
  players: GameResultResponse['players'];
  table: GameResultResponse['table'];
}

interface TableUpdateHandlerQueue {
  data:
    | GameLogicInterface.Table
    | GameResultHandlerType
    | Pick<
        GameRoomGeneralResponse,
        | 'tablePlayers'
        | 'isInsuranceTriggered'
        | 'isResultShown'
        | 'currentPlayerIndex'
        | 'currentPot'
        | 'prevPot'
      >
    | BestCombinationResult;
  options: {isUpdateMyHands?: boolean; omitPlayerProps?: string[]};
  type: 'TABLE_UPDATE' | 'RESULT' | 'GENERAL' | 'PRIVATE_INFO';
}

const SIDE_POT_INTERVAL = 4000; // 2 sec
export const TABLE_MESSAGE_DURATION_MS = 3000;
const RESULT_PAUSE_MS = 1500;
const STICKER_ANIMATION_TIMEOUT = 2000;
const silentSoundPath = '/audio/silence.mp3';
const allInMusicPath = '/audio/all-in-bgm.mp3';

// * "BET" | "CALL" | "CHECK" | "RAISE" | "FOLD" | "BB" | "SB" | "ANTE" | "ALL_IN"
const MOCK_ACTIONS = ['CALL', 'CHECK', 'BET'] as GameLogicInterface.Action[];
const MOCK_OPTIONS = [
  {
    unit: 'POT',
    unitValue: 50,
    betValue: 100,
  },
  {
    unit: 'POT',
    unitValue: 2,
    betValue: 200,
  },
  {
    unit: 'POT',
    unitValue: 75,
    betValue: 150,
  },
] as GameRoomInterface.ShortcutOption[];

const NEXT_PUBLIC_URL = env('NEXT_PUBLIC_URL');
const NEXT_PUBLIC_RUNTIME_ENV = env('NEXT_PUBLIC_RUNTIME_ENV');
// const {Countdown} = Statistic;

const getMockPlayer = (index: number, isOmaha: boolean) => {
  return isOmaha ? mockPlayersOmaha(index) : mockPlayer(index);
};

console.log('NEXT_PUBLIC_RUNTIME_ENV', NEXT_PUBLIC_RUNTIME_ENV);

// TODO prevent re-render
const TablePopup = React.memo(
  ({id, visible, children}: {id?: string; visible: boolean; children}) => {
    const {classes} = useCommon({
      withStyles: styles,
      observers: ['socket', 'user'],
      withTranslation: ['game_room'],
    });
    // console.log(' *** TablePopup *** ');
    return (
      <div id={id} className={classNames(classes.forceQuitModal, !visible && classes.hidden)}>
        {children}
      </div>
    );
  }
);
TablePopup.displayName = 'TablePopup';

const GameRoom = React.forwardRef((props: GameRoomComponent, ref) => {
  const {classes, socket, t, user, game, system, theme} = useCommon({
    withStyles: styles,
    observers: ['socket', 'user', 'game', 'system'],
    withTranslation: ['game_room'],
  });

  const isDebugView = useDebugView();

  const {
    tableIndex,
    tableInfo,
    encryptionKey,
    setIsWithdrawChipsBtnShown,
    setIsDepositChipsBtnShown,
    setIsEmojiBtnShown,
    isGameRoomMuted,
    isGameOverlayShown,
    isTableActive,
    onAudioError,
  } = props;

  // TODO: Deprecate this code
  useEffect(() => {
    setCardSoundSrc('/audio/silence.mp3');
    setMyTurnSoundSrc('/audio/silence.mp3');
    setAudioSrc('/audio/silence.mp3');
    setVoiceSrc('/audio/silence.mp3');
    setWinnerSoundSrc('/audio/silence.mp3');
    const allInBgmRef = allInBackgroundMusicAudioRef?.current;
    if (allInBgmRef) {
      allInBgmRef.pause();
      allInBgmRef.currentTime = 0;
      audioRef.current.play().catch((error: Error) => {
        if (error.name === 'NotAllowedError') {
          console.log(' --- NotAllowedError --- ');
          onAudioError();
        } else {
          console.log(' --- audio related err --- ', error.message);
        }
      });
      //! may need to call onAudioError() here
      voiceRef.current.play().catch(error => {});
      winnerSoundEffectRef.current.play().catch(error => {});
    }
  }, [isGameRoomMuted]);

  const isCurrentTableInView = isTableActive && isGameOverlayShown;
  const isCurrentTableInViewPrev = usePrevious(isCurrentTableInView);

  const shouldAudioBePlayed = isCurrentTableInView && !isGameRoomMuted;
  const tableRef = useRef<any>();
  const extendTimerRef = useRef<any>();
  const tableMessageTimeout = useRef<NodeJS.Timeout>();
  const emojiToBeFired = useRef<EmojiIdentifier>();
  const communityHandsRef = useRef<Array<PokerComponent>>();
  const isCurrentTableInViewRef = useRef<boolean>();
  const hasResult = useRef<boolean>();
  const gameIdRef = useRef<number>();
  const maxBuyInRef = useRef<number>();
  const audioRef = useRef<HTMLAudioElement>();
  const voiceRef = useRef<HTMLAudioElement>();
  const allInBackgroundMusicAudioRef = useRef<HTMLAudioElement>();
  const winnerSoundEffectRef = useRef<HTMLAudioElement>();
  const cardSoundRef = useRef<HTMLAudioElement>();

  const printDebugCount = useRef<number>(0);
  const myBestCombinationRef = useRef<BestCombination>();
  const myTurnSoundTimeoutRef = useRef<NodeJS.Timeout>();
  const myTurnSoundFirst5SecTimeoutRef = useRef<NodeJS.Timeout>();

  // const allInAudioSrcRef = useRef<AudioBufferSourceNode>();
  // const isAudioUnlockedRef = useRef<boolean>(false);

  // To avoid new table events interupt animations
  const isTableUpdatingRef = useRef<boolean>(false);
  const prevTableStatesRef = useRef<GameLogicInterface.Table>(null);

  const myTurnSoundEffectRef = useRef<HTMLAudioElement>();
  const isAudioUnlockedRef = useRef<boolean>(false);

  // useEffect(() => {
  //   if (isCurrentTableInView === true && isCurrentTableInViewPrev === false) {
  //     // Let table fetch the newest state when switch to current table
  //     reconnect();
  //   }
  // }, [isCurrentTableInView, isCurrentTableInViewPrev]);

  useImperativeHandle(
    ref,
    () => ({
      directGameInviteHandler,
      buyInAgainHandler,
      roomInitHandler,
      gameInitHandler,
      playerInActionHandler,
      playerFoldHandler,
      tableUpdateHandler: (data: GameLogicInterface.Table) => {
        setTableUpdateQueue(prev => [...prev, {data, options: null, type: 'TABLE_UPDATE'}]);
      },
      gameRestartHandler,
      gameResultHandler: (data: GameResultHandlerType) => {
        setTableUpdateQueue(prev => [...prev, {data, options: null, type: 'RESULT'}]);
      },
      stickerHandler,
      insuranceHandler,

      privateInfoHandler,
      yourTurnHandler,
      tournamentPlayerRankingHandler,
      tournamentResultAnnouncementHandler,
      tournamentRebuyInviteHandler,
      tournamentStackHandler,
      tournamentThanksForJoiningHandler,
      tournamentCancelHandler,
      tournamentWaitingForPlayersHandler,
      tournamentWaitingStatusUpdateHandler,
      gameRoomComponentOnAfkNotification,
      gameRoomComponentOnExitRoomNotification,

      gameRoomComponentOnCopy,
      gameRoomComponentOnShare,
      gameRoomComponentOnClickEmoji,
      gameRoomComponentOnClickHistory,
      gameRoomComponentOnClickWithdrawExtraBet,
      gameRoomComponentOnClickAddExtraBet,
      gameRoomComponentOnAddExtraBetSuccess,
      gameRoomComponentOnRemaining,
      gameRoomComponentOnExpired,

      gameRoomComponentOnBuyInResp,
      gameRoomComponentOnTopupResp,
      gameRoomComponentOnWithdrawBetResp,
      gameRoomComponentOnSwitchToObserverResp,
      // gameRoomComponentOnExtendPrivateRoomResp,
      gameRoomComponentOnSetActionResult,
      gameRoomComponentOnSitInResult,
      gameRoomComponentOnSitOutResult,

      quitTable,
      sitOut,
      sitIn,
      sitOutPopUp,
      sitOutKick,
      disconnectTable,
      reconnect,
      buyInExpiredHandler,
      dismissTimerModals,

      joinRoomErrorHandler,

      // unlockAudio,
    }),
    [tableInfo, encryptionKey]
  );

  const isOmaha = tableInfo?.gameType === 'OMAHA';
  const isTournament = tableInfo?.roomType === 'TOURNAMENT';

  const [isLoadingGameState, setIsLoadingGameState] = useState<boolean>(false);
  const [isInAppBrowser, setIsInAppBrowser] = useState(false);
  const [shouldMusicBePlayed, setShouldMusicBePlayed] = useState(false);
  const [isRegularTable, setIsRegularTable] = useState<boolean>(true);
  const [hasMockPlayers, setHasMockPlayers] = useState<boolean>(true);
  const [allPlayers, setAllPlayers] = useState<Array<PlayerComponent>>(
    isDebugView
      ? // TODO debug
        (() => {
          const mockPlayers: Array<PlayerComponent> = Array(6);
          for (let iii = 0; iii <= 5; iii += 1) {
            mockPlayers[iii] = getMockPlayer(iii, isOmaha);
          }
          return mockPlayers;
        })()
      : Array(6).fill(null)
  );
  const [waitList, setWaitList] = useState<any>([]);

  // TODO: eliminate derived state
  const [myHands, setMyHands] = useState<Array<PokerComponent>>(
    isDebugView ? Array(4).fill(mockCard) : []
  );
  const [communityHands, setCommunityHands] = useState<Array<PokerComponent>>(
    isDebugView ? mockCommunityCard : []
  );

  // const [sliderExpanded, setSliderExpanded] = useState(false);
  const isDesktop = theme?.currentStyleFormat?.id === 'desktop';
  const router = useRouter();
  const isDebug = router && router.query.isDebug === 'true';

  const GAME_EVENTS_V3 = getGameEventV3();

  const [availableActions, setAvailableActions] = useState<Array<GameLogicInterface.Action>>(
    isDebugView ? MOCK_ACTIONS : []
  );
  const [currentMoney, setCurrentMoney] = useState<number>(0);
  // const [buyInQuota, setBuyInQuota] = useState<number>(0);
  const [playerInActionOrder, setPlayerInActionOrder] = useState<number>(isDebugView ? 2 : null);

  const [insuranceInfo, setInsuranceInfo] = useState<GameLogicInterface.Insurance>(
    isDebugView ? mockInsuranceInfo : null
  );
  const [insuranceExpireAt, setInsuranceExpireAt] = useState<string>(null);

  const [outCards, setOutCards] = useState<Array<PokerComponent>>(
    isDebugView ? mockInsuranceInfo.outs : null
  );

  const [actionKey, setActionKey] = useState<string>();
  // TODO
  // const [currentBetValue, setCurrentBetValue] = useState<number>(0);
  // const [currentDecisionString, setCurrentDecisionString] = useState<string>('');

  const [basicBet, setBasicBet] = useState<number>(0); // i.e. SB
  const [potValue, setPotValue] = useState<number>(0);
  const [prevPot, setPrevPot] = useState<number>(isDebugView ? 10 : 0);
  const [gameRoomType, setGameRoomType] = useState(null);
  const [gameId, setGameId] = useState<number>(null);
  const [myBestCombination, setMyBestCombination] = useState<BestCombination>(
    isDebugView ? {combinationName: 'HI_CARD', displayValue: 14, cards: []} : null
  );
  const [myAutoAction, setMyAutoAction] = useState<AutoAction>(null);
  const [minBet, setMinBet] = useState<number>(0);
  const [maxBet, setMaxBet] = useState<number>(0);
  const [callAmount, setCallAmount] = useState<number>(0);
  // const [gameResult, setGameResult] = useState<GameResult>(isDebugView ? mockResult : null);
  const [gameResult, setGameResult] = useState<{
    result: GameLogicInterface.Result[];
    gameId: number;
    players: GameLogicInterface.Player[];
  }>(null);
  const [waitingTime, setWaitingTime] = useState<number>(null);
  const [privateRoomExpireTime, setPrivateRoomExpireTime] = useState<any>(null);
  const [currentRoomMasterId, setCurrentRoomMasterId] = useState<number>(null);
  const [gameResultOnScreen, setGameResultOnScreen] = useState<GameResultOnScreen>(null);

  const [isBuyInVisible, setIsBuyInVisible] = useState<boolean>(false);
  const [buyInExpiredAt, setBuyInExpiredAt] = useState<string>();
  const [maxBuyInAmount, setMaxBuyInAmount] = useState<number>(0);
  const [buyInToken, setBuyInToken] = useState<string>();
  const [walletBalance, setWalletBalance] = useState<number>(null);

  const [isOpenChatRoom, setIsOpenChatRoom] = useState<boolean>(false);

  const [isDisableAllActions, setIsDisableAllActions] = useState<boolean>(false);
  const [isEmojiDrawerVisible, setIsEmojiDrawerVisible] = useState<boolean>(false);
  const [isHistoryDrawerVisible, setIsHistoryDrawerVisible] = useState<boolean>(false);
  const [isWithdrawExtraBetVisible, setIsWithdrawExtraBetVisible] = useState<boolean>(false);
  const [isAddExtraBetVisible, setIsAddExtraBetVisible] = useState<boolean>(false);

  const [isDebugPrintVisible, setIsDebugPrintVisible] = useState<boolean>(false);
  const [debugPrintItems, setDebugPrintItems] = useState<DescriptionsItemType[]>(null);

  const [emojiStatus, setEmojiStatus] = useState<EmojiStatus>();
  const [roomMessage, setRoomMessage] = useState<RoomMessage>(null);
  const [forceQuitMoment, setForceQuitMoment] = useState<string>(null);
  const [expiredTime, setExpiredTime] = useState<number>(null);
  const [isForceQuitModalVisible, setIsForceQuitModalVisible] = useState<boolean>(false);
  const [isSitOutModalVisible, setIsSitOutModalVisible] = useState<boolean>(null);
  const [isTournamentTableBalancingModalVisible, setIsTournamentTableBalancingModalVisible] =
    useState<boolean>(false);
  const [isReconnectModalVisible, setIsReconnectModalVisible] = useState<boolean>(false);
  const [isExtendRoomModalVisbile, setIsExtendRoomModalVisbile] = useState<boolean>(false);
  const [isExpiredRoomModalVisbile, setIsExpiredRoomModalVisbile] = useState<boolean>(false);
  const [isTimeSpanVisibile, setIsTimeSpanVisibile] = useState<boolean>(false);
  const [isRoomMasterTimeSpanVisibile, setIsRoomMasterTimeSpanVisibile] = useState<boolean>(false);
  const [audioSrc, setAudioSrc] = useState<string>(silentSoundPath);
  const [voiceSrc, setVoiceSrc] = useState<string>(silentSoundPath);
  const [cardSoundSrc, setCardSoundSrc] = useState<string>(silentSoundPath);
  const [winnerSoundSrc, setWinnerSoundSrc] = useState<string>(silentSoundPath);
  const [myTurnSoundSrc, setMyTurnSoundSrc] = useState<string>(silentSoundPath);
  const [allInBgmSrc, setAllInBgmSrc] = useState<string>(silentSoundPath);
  const [shortcutOptions, setShortcutOptions] = useState<GameRoomInterface.ShortcutOption[]>(
    isDebugView ? MOCK_OPTIONS : []
  );
  const [emojiSenderId, setEmojiSenderId] = useState<number>(null);
  const [emojiReceiverId, setEmojiReceiverId] = useState<number>(null);
  const [isEmojiSending, setIsEmojiSending] = useState<boolean>(false);
  const [isEmojiButtonShown, setIsEmojiButtonShown] = useState<boolean>(false);
  const [componentsPositions, setComponentsPositions] = useState<ComponentsPositions>({});
  const [playerIconCenterPositions, setPlayerIconCenterPositions] = useState([]);
  const [playerChipPlacement, setPlayerChipPlacement] = useState(Array(6).fill(null));
  const [scaleUpValue, setScaleUpValue] = useState<number>(1);
  const [dealerButtonPosition, setDealerButtonPosition] = useState<number>(null);
  const [stickerAnimationQueue, setStickerAnimationQueue] = useState<Array<EmojiStatus>>([]);
  const [stickerTimeoutId, setStickerTimeoutId] = useState(null);
  const stickerAnimationQueueRef = useRef(stickerAnimationQueue);
  const stickerTimeoutIdRef = useRef(stickerTimeoutId);
  const [currentPlayerActionExpireAt, setCurrentPlayerActionExpireAt] = useState<string>(null);
  const [currentPlayerActionTotalDuration, setCurrentPlayerActionTotalDuration] =
    useState<number>(null);
  const [buttonLoadingState, setButtonLoadingState] = useState<ButtonLoadingState>(null);
  const [isBuyInLoading, setIsBuyInLoading] = useState(false);
  const [shouldSlideDownButtons, setShouldSlideDownButtons] = useState<boolean>(false);
  const [shouldSlideDownButtonsBroadcast, setShouldSlideDownButtonsBroadcast] =
    useState<boolean>(false);
  const [isReturnedToBrowser, serIsReturnedToBrowser] = useState<boolean>(false);

  const [tableUpdateQueue, setTableUpdateQueue] = useState<TableUpdateHandlerQueue[]>([]);
  const [isTableAnimating, setIsTableAnimating] = useState<boolean>(false);

  const [isMyHandVisibleInBubble, setIsMyHandVisibleInBubble] = useState<boolean>(true);

  const [isJoinRoomErrorVisible, setIsJoinRoomErrorVisible] = useState<boolean>(false);
  const [joinRoomErrorCode, setJoinRoomErrorCode] = useState<string>(null);

  const [isSitOutTournamentWarningVisible, setIsSitOutTournamentWarningVisible] =
    useState<boolean>(false);

  const [tournamentPlayerRankings, setTournamentPlayerRankings] =
    useState<Array<{playerId: number; rank: number}>>(null);
  const [tournamentStartTime, setTournamentStartTime] = useState<string>(null);
  const [tournamentId, setTournamentId] = useState<number>(null);

  const [isTournamentResultModalOpen, setIsTournamentResultModalOpen] = useState<boolean>(false);
  const [isTournamentReEntryModalOpen, setIsTournamentReEntryModalOpen] = useState<boolean>(false);
  const [isTournamentThanksForJoiningModalOpen, setIsTournamentThanksForJoiningModalOpen] = useState<boolean>(false);
  const [tournamentRebuyInviteData, setTournamentRebuyInviteData] = useState<{
    tournamentName: string;
    tournamentTicketFee: number;
  }>(null);
  const [tournamentThanksData, setTournamentThanksData] = useState<{
    tournamentName: string;
    tournamentId: number;
  }>(null);
  const [isTournamentCancelModalOpen, setIsTournamentCancelModalOpen] = useState<boolean>(false);
  const [tournamentCancelData, setTournamentCancelData] = useState<{
    tournamentName: string;
    refundAmount?: number;
  }>(null);
  const [isTournamentWaitingForPlayersModalOpen, setIsTournamentWaitingForPlayersModalOpen] = useState<boolean>(false);
  const [tournamentWaitingData, setTournamentWaitingData] = useState<{
    tournamentName: string;
    currentPlayers: number;
    minPlayersRequired: number;
  }>(null);
  const [tournamentWaitingStatus, setTournamentWaitingStatus] = useState<string>(null);
  const [tournamentWaitingStatusData, setTournamentWaitingStatusData] = useState<{
    currentPlayers: number;
    minPlayersRequired: number;
    remainingPlayers: number;
    remainingTimeMinutes: number;
    message: string;
    cancelTime?: string;
  }>(null);

  const [tournamentResult, setTournamentResult] = useState<{
    tournamentName: string;
    result: {
      rank: number;
      prize: number;
    };
  }>(null);
  const [tournamentStack, setTournamentStack] = useState<{
    ante: number;
    bigBlind: number;
    smallBlind: number;
    nextAnte: number;
    nextBigBlind: number;
    nextSmallBlind: number;
    nextUpdateAt: number;
  }>(null);

  // useWhyDidYouUpdate('GameRoom', {...props});
  // useWhyDidYouUpdate(`GameRoom${tableIndex}`, {shouldSlideDownButtons});

  const {runAsync: getRoomInfoData, data: roomInfoData} = useRequest(gameApi.getRoomInfo, {
    manual: true,
  });

  const resetRoom = () => {
    tableUpdateHandler({
      roomCode: null,
      gameId: 0,
      currentPot: 0,
      players: [null, null, null, null, null, null],
      communityCards: [],
      playerInAction: -1,
      prevPot: 0,
      minBet: 0,
      callAmount: 0,
      currentPlayerActionExpireAt: null,
      currentPlayerActionTotalDuration: null,
      isNewStreet: false,
      isPlayCardFlipAnimation: false,
      isCleanTable: true,
      soundEffect: null,
      currentPlayerTimeBankExpiredAt: null,
      currentPlayerTimeBankEnable: false,
      buttonPosition: -1,
      isInsuranceTriggered: false,
      isResultShown: false,
    });
  };

  const setMockTable = () => {
    tableUpdateHandler(getMockTableInfo({gameType: tableInfo?.gameType, hasResult: false}) as any);

    setGameResult(null);
    setGameResultOnScreen(null);
    setMyBestCombination(null);
  };

  const {query} = router;
  const currentRoom = query?.currentRoom;

  // * in case Stark is not happy with the current implementation
  const getQuitRoomResult = async () => {
    console.log(' ### currentRoom', currentRoom);
    try {
      const result = await user?.getPlayerInfo();
      console.log(' ### joinedRooms:', result?.joinedRoom);

      const observerRooms = result?.joinedRoom?.filter(room => room?.isObserver);
      console.log(' ### observerRooms:', observerRooms);
      const hasExited = observerRooms.some(room => room?.roomCode === currentRoom);
      console.log(' ### hasExited:', hasExited);

      if (hasExited) {
        router.push({
          pathname: 'home',
          query: {},
        });
        system?.hideGameOverlay();
      }
    } catch (error) {
      console.log(' ### error', error);
    }
  };

  // * handle user switch back/away from browser
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (isDesktop) return;
      if (document.visibilityState === 'visible') {
        // getQuitRoomResult();
        serIsReturnedToBrowser(true);
        setTimeout(() => {
          serIsReturnedToBrowser(false);
        }, 3000);
      } else {
        console.log('switched away from browser');
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isDesktop]);

  useEffect(() => {
    if (tableInfo?.roomCode != null) {
      getRoomInfoData(tableInfo?.roomCode, user?.getPlayerToken());
    } else {
      resetRoom();
    }
  }, [tableInfo]);

  // useEffect(() => {
  //   updateChipsButtonState(currentMoney, myPlayer.isActive);
  // }, [currentMoney]);

  const handleStickerComplete = (timestamp: any): void => {
    setStickerAnimationQueue(prevQueue => {
      if (!prevQueue) {
        return [];
      }
      if (prevQueue.length === 0) {
        return prevQueue;
      }

      const filteredArray = prevQueue.filter(obj => obj?.timestamp !== timestamp);

      return filteredArray;
    });
  };

  useEffect(() => {
    // console.log('roomNumber', tableInfo);
    if (tableInfo !== null && typeof tableInfo !== 'undefined') {
      setGameInfoInGameStore(tableInfo.roomCode);
    }
  }, [tableInfo]);

  useEffect(() => {
    // console.log(
    //   'animation queue changed',
    //   tableUpdateQueue,
    //   tableUpdateQueue?.length,
    //   isTableAnimating
    // );
    if (!isTableAnimating && tableUpdateQueue?.length > 0) {
      const nextAnimation = tableUpdateQueue[0];
      // console.log('animation queue executing', nextAnimation);
      setIsTableAnimating(true);
      if (nextAnimation.type === 'TABLE_UPDATE') {
        tableUpdateHandler(nextAnimation.data as GameLogicInterface.Table, nextAnimation.options);
      } else if (nextAnimation.type === 'RESULT') {
        const {players, result, table} = (nextAnimation.data as GameResultHandlerType) || {};
        gameResultHandler(result, players, table);
      } else if (nextAnimation.type === 'GENERAL') {
        generalResponseUIUpdateHandler(nextAnimation.data);
      } else if (nextAnimation.type === 'PRIVATE_INFO') {
        privateInfoUIUpdateHandler(nextAnimation.data);
      } else {
        throw new Error('Queue type undefined');
      }
    }
  }, [tableUpdateQueue, isTableAnimating]);

  const getMyPlayerId = () => get(user, 'playerInfo.id', null);

  const getMyPlayer = (players, playerId) => {
    if (isDebugView) return players?.find(player => player?.order === 0);
    const myPlayer = players?.find(player => player && player.id === playerId);
    return myPlayer;
  };

  useEffect(() => {
    const myPlayerId = getMyPlayerId();
    const myPlayer = getMyPlayer(allPlayers, myPlayerId);

    updateTabBubbleContent({
      actionDuration: currentPlayerActionTotalDuration,
      actionExpireAt: currentPlayerActionExpireAt,
      actionOrder: playerInActionOrder,
      pot: potValue,
      hands: myHands,
      player: myPlayer,
      isMyHandVisibleInBubble,
    });
  }, [
    isMyHandVisibleInBubble,
    potValue,
    playerInActionOrder,
    currentPlayerActionExpireAt,
    currentPlayerActionTotalDuration,
    allPlayers,
    myHands,
    socket,
  ]);

  const setGameInfoInGameStore = async (roomCode: string) => {
    if (isDebugView) {
      game?.setBigBlind(mockRoomInfo.big_blind);
      game?.setSmallBlind(mockRoomInfo.small_blind);
      game?.setGameMode(mockRoomInfo.game_mode);
    } else {
      const response = await getRoomInfoData(roomCode, user?.getPlayerToken());
      const {smallBlind, bigBlind, gameType} = response.playroom;
      game?.setBigBlind(bigBlind);
      game?.setSmallBlind(smallBlind);
      game?.setGameMode(gameType);
    }
  };

  const {bigBlind, minBuyIn, maxBuyIn, smallBlind, actionTime} = roomInfoData?.playroom || {};

  const currencyId = useCurrencyId();

  const spinIcon = <LoadingOutlined className={classes.spinIcon} spin />;

  const updatePlayersState = (
    updatedPlayers: Array<GameLogicInterface.Player>,
    isHandRevealed?: boolean,
    omitProperty?: string[]
  ): void => {
    setAllPlayers(originalPlayers => {
      return updatedPlayers.map(updatedPlayerInfo => {
        const originalPlayerInfo = originalPlayers.find(
          originalPlayer =>
            updatedPlayerInfo && originalPlayer && updatedPlayerInfo.id === originalPlayer.id
        );

        if (isEqual(originalPlayerInfo, updatedPlayerInfo)) {
          return originalPlayerInfo;
        }

        const filtered = omit(updatedPlayerInfo, omitProperty);

        const obj = {...originalPlayerInfo, ...filtered};
        if (
          !filtered ||
          (Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype)
        ) {
          return null;
        }

        // prevent overriding game result when new player joins
        if (isHandRevealed && originalPlayerInfo?.hand?.length > 0) {
          return {...originalPlayerInfo, remainingMoney: updatedPlayerInfo?.remainingMoney};
        }
        return obj;
      });
    });
  };

  const highlightCards = (resultCombination: Array<GameLogicInterface.CardObj>): void => {
    const getCardState = (card: GameLogicInterface.CardObj): PokerComponent['state'] => {
      if (!resultCombination) {
        return 'NORMAL';
      }
      const isSelected = resultCombination.some(
        ({suit, rank}) => suit === card.suit && rank === card.rank
      );
      return isSelected ? 'RAISED' : 'DARKEN';
    };

    const highlightedCards = communityHands.map(hand => ({
      ...hand,
      state: getCardState(hand),
      hasReachedResult: true,
    }));

    setCommunityHands(highlightedCards);
    setMyHands(hands =>
      hands
        ? hands.map(hand => ({
            ...hand,
            state: getCardState(hand),
          }))
        : null
    );
    setAllPlayers(players => {
      return players.map(player => {
        if (!player) {
          return null;
        }
        const highlightedHand = player.hand
          ? player.hand.map(playerHand => {
              return {
                ...playerHand,
                state: getCardState(playerHand),
              };
            })
          : null;

        return {
          ...player,
          hand: highlightedHand,
        };
      });
    });
  };

  // const getWinnerIndexByUsername = (username: string): number => {
  //   const {players} = gameResult;
  //   if (!Array.isArray(players)) return null;
  //   const winnerIndex = players.findIndex(obj => obj.username === username);
  //   return winnerIndex;
  // };

  // TODO
  const updateGameResultOnScreen = (result: GameLogicInterface.Result) => {
    const {
      potSequence,
      winAmountForPlayer,
      potWinnerIds,
      combinationName,
      selectedCards,
      cardValues,
    } = result;
    highlightCards(selectedCards);
    setGameResultOnScreen(result);
    delayedFunction(() => {
      // TODO: adapter from order to ID
      tableRef.current?.moveChipsToPlayers(result.potWinnerIds);
    }, 300);
  };

  const {
    loading: getLoading,
    data: emojiList,
    runAsync: getEmojiList,
  } = useRequest(diamondItemsApi.getStickers, {
    manual: true,
    onError: error => {
      console.log('getStickers - error', error);
    },
  });

  const {data: itemList, runAsync: getItemList} = useRequest(playerItemApi.getPlayerItem, {
    manual: true,
    onError: error => {
      console.log('getPlayerItem - error', error);
    },
  });

  const playWinnerSoundEffect = (): void => {
    if (winnerSoundSrc && winnerSoundEffectRef.current) {
      winnerSoundEffectRef.current.src = winnerSoundSrc;
      winnerSoundEffectRef.current.play().catch(error => {
        // console.log(' ** err in playWinnerSoundEffect() in winnerSoundEffectRef ** ', error);
      });
    }
  };

  const playMyTurnSoundEffect = (): void => {
    if (myTurnSoundSrc && myTurnSoundEffectRef.current) {
      myTurnSoundEffectRef.current.src = myTurnSoundSrc;
      myTurnSoundEffectRef.current.play().catch(error => {
        // console.log(' ** err in playMyTurnSoundEffect() ** ', error);
        if (NEXT_PUBLIC_RUNTIME_ENV !== 'production' && NEXT_PUBLIC_RUNTIME_ENV !== 'staging') {
          notification.error({message: error.message});
        }
      });
    }
  };

  const playAllInBgm = (): void => {
    if (allInBgmSrc && allInBackgroundMusicAudioRef.current) {
      allInBackgroundMusicAudioRef.current.src = allInBgmSrc;
      allInBackgroundMusicAudioRef.current.play().catch(error => {
        // console.log(' ** err in playMyTurnSoundEffect() ** ', error);
        if (NEXT_PUBLIC_RUNTIME_ENV !== 'production' && NEXT_PUBLIC_RUNTIME_ENV !== 'staging') {
          notification.error({message: error.message});
        }
      });
    }
  };

  useEffect(() => {
    getEmojiList();
    if (user) {
      getItemList(user?.getPlayerToken());
    }
    setIsLoadingGameState(true);
  }, [user]);

  // setShouldMusicBePlayed(false) when music ends, otherwise no sound next time
  useEffect(() => {
    const audioRef = allInBackgroundMusicAudioRef.current;
    if (!audioRef) return;

    const handleAudioEnded = () => {
      setShouldMusicBePlayed(false);
    };

    audioRef.addEventListener('ended', handleAudioEnded);

    return () => {
      audioRef.removeEventListener('ended', handleAudioEnded);
    };
  }, [shouldMusicBePlayed]);

  // handle shouldMusicBePlayed
  useEffect(() => {
    const allInBgmRef = allInBackgroundMusicAudioRef.current;
    if (!allInBgmRef) return;

    if (shouldMusicBePlayed && !isGameRoomMuted) {
      allInBgmRef.play().catch(error => {
        // console.log(' ## err in allInBgmRef ## ', error);
      });
    } else {
      allInBgmRef.pause();
      allInBgmRef.currentTime = 0;
    }
  }, [shouldMusicBePlayed]);

  useEffect(() => {
    // otherwise if soundEffect is the same in a row after changing table, it won't play
    setCardSoundSrc(null);
    setMyTurnSoundSrc(null);
    setAudioSrc(null);
    setVoiceSrc(null);
    setWinnerSoundSrc(null);
    if (!shouldAudioBePlayed) {
      // for all in bgm
      setShouldMusicBePlayed(false);
    }
  }, [isTableActive]);

  useEffect(() => {
    const winnerSoundRef = winnerSoundEffectRef.current;
    if (!winnerSoundRef) return;

    const handleAudioEnded = () => {
      setWinnerSoundSrc(silentSoundPath);
    };

    winnerSoundRef.addEventListener('ended', handleAudioEnded);

    return () => {
      winnerSoundRef.removeEventListener('ended', handleAudioEnded);
    };
  }, [winnerSoundSrc]);

  useEffect(() => {
    if (shouldAudioBePlayed) {
      playWinnerSoundEffect();
    }
  }, [winnerSoundSrc]);

  useEffect(() => {
    const myTurnSoundRef = myTurnSoundEffectRef.current;
    if (!myTurnSoundRef) return;

    const handleAudioEnded = () => {
      setMyTurnSoundSrc(silentSoundPath);
    };

    myTurnSoundRef.addEventListener('ended', handleAudioEnded);

    return () => {
      myTurnSoundRef.removeEventListener('ended', handleAudioEnded);
    };
  }, [myTurnSoundSrc]);

  useEffect(() => {
    if (shouldAudioBePlayed) {
      playMyTurnSoundEffect();
    }
  }, [myTurnSoundSrc]);

  useEffect(() => {
    const allInBgmRef = allInBackgroundMusicAudioRef.current;
    if (!allInBgmRef) return;

    const handleAudioEnded = () => {
      setAllInBgmSrc(silentSoundPath);
    };

    allInBgmRef.addEventListener('ended', handleAudioEnded);

    return () => {
      allInBgmRef.removeEventListener('ended', handleAudioEnded);
    };
  }, [allInBgmSrc]);

  useEffect(() => {
    if (shouldAudioBePlayed) {
      playAllInBgm();
    }
  }, [allInBgmSrc]);

  const increasePlayerMoneyOnPotDistribution = (playerIds: number[], amount: number) => {
    if (!playerIds || !amount) return;

    setAllPlayers(originalPlayers => {
      return originalPlayers.map(player => {
        if (!player || !playerIds.includes(player?.id)) {
          return player;
        }

        const originalMoney = player.remainingMoney;
        const newMoney = new BigNumber(originalMoney).plus(amount).toNumber();

        const obj = {...player, remainingMoney: newMoney};

        // // prevent overriding game result when new player joins
        // if (originalMoney?.hand?.length > 0) {
        //   return originalMoney;
        // }
        return obj;
      });
    });
  };

  useEffect(() => {
    const handleResult = async () => {
      if (!gameResult) return;
      // Socket callback won't read current states properly
      console.log('handleResult', gameResult);
      const winAmountByPlayer = gameResult?.result?.reduce((acc, pot) => {
        pot.potWinnerIds.forEach(playerId => {
          if (!acc[playerId]) {
            acc[playerId] = new BigNumber(pot.winAmountForPlayer);
          } else {
            acc[playerId] = acc[playerId].plus(pot.winAmountForPlayer);
          }
        });
        return acc;
      }, {});

      const playersWithBalanceBeforeChipDistribution = gameResult?.players?.map(player => {
        if (!player) return null;
        return {
          ...player,
          remainingMoney: Math.max(
            BigNumber(player.remainingMoney)
              .minus(winAmountByPlayer[player.id] ?? 0)
              .toNumber(),
            0
          ), // May result in negative money due to rake
        };
      });
      updatePlayersState(playersWithBalanceBeforeChipDistribution, true);

      hasResult.current = Boolean(gameResult);
      gameResult?.result?.forEach((pot, index) => {
        setTimeout(() => {
          // TODO
          console.log(
            'setTimeout gameResult.gameId, gameIdRef.current',
            gameResult.gameId,
            gameIdRef.current
          );
          if (isDebugView || gameResult.gameId >= (gameIdRef.current ?? 0)) {
            console.log('updating game result on screen', pot, index);
            updateGameResultOnScreen(pot);
            setTimeout(() => {
              if (index === gameResult.result.length - 1) {
                updatePlayersState(gameResult?.players, true);
              } else {
                increasePlayerMoneyOnPotDistribution(pot?.potWinnerIds, pot?.winAmountForPlayer);
              }
            }, CHIP_TRANSITION_DURATION + 300);
            setAudioSrc('/audio/sound-effect/bet.mp3');
            setWinnerSoundSrc('/audio/win.mp3');
            if (index === gameResult.result.length - 1) {
              const data = {roomCode: tableInfo.roomCode};
              setTimeout(() => {
                socket?.call(GAME_EVENTS_V3.EM_PLAYER_SET_RESTART_GAME, {
                  roomCode: tableInfo.roomCode,
                  data,
                });
              }, SIDE_POT_INTERVAL);
            }
          }
        }, SIDE_POT_INTERVAL * index);
      });
    };

    handleResult();
  }, [gameResult]);

  useEffect(() => {
    const handleMaxBuyInUpdate = async () => {
      // Socket callback won't read current states properly
      maxBuyInRef.current = Number(maxBuyIn);
    };
    handleMaxBuyInUpdate();
  }, [maxBuyIn]);

  useEffect(() => {
    // Socket callback won't read current states properly
    communityHandsRef.current = communityHands;
  }, [communityHands]);

  useEffect(() => {
    // Socket callback won't read current states properly
    isCurrentTableInViewRef.current = isCurrentTableInView;
  }, [isCurrentTableInView]);

  const ROOM_TYPE = {
    PRIVATE: 'PRIVATE',
    PUBLIC: 'PUBLIC',
  };

  const ANIMATION_COMPLETION_TIME = 1500;

  const generalResponseUIUpdateHandler = (data: {
    tablePlayers;
    isInsuranceTriggered;
    isResultShown;
    currentPot;
    prevPot;
    currentPlayerIndex;
  }) => {
    try {
      const {
        tablePlayers,
        isInsuranceTriggered,
        isResultShown,
        currentPlayerIndex,
        currentPot,
        prevPot,
      } = data || {};

      updatePlayersState(
        tablePlayers,
        isInsuranceTriggered || isResultShown,

        // Handle remainingMoney in tableUpdateHandler and resultHandler when result is reached
        isResultShown ? ['remainingMoney'] : []
      );
      const totalPot = new BigNumber(currentPot).plus(prevPot).toNumber();
      setPotValue(totalPot);
      setPrevPot(prevPot);
      setPlayerInActionOrder(currentPlayerIndex);

      onTableAnimationFinish();
    } catch (error) {
      onTableAnimationFinish();
    }
  };

  const roomInitHandler = (roomInfo: GameRoomInterface.GameRoomGeneralResponse) => {
    if (!roomInfo || !isCurrentTableInViewRef?.current) return;
    if (roomInfo?.gameId < gameIdRef.current) return;

    setTimeout(() => {
      setIsLoadingGameState(false);
    }, ANIMATION_COMPLETION_TIME);
    const {
      currentPot,
      prevPot,
      waitingList,
      tablePlayers,
      smallBlind,
      currentPlayerIndex,
      roomExpireAt,
      createdByPlayerId,
      roomType,
      isInsuranceTriggered,
      isResultShown,
      tournamentStartAt,
      tournamentId,
    } = roomInfo;
    setGameRoomType(roomType);
    if (!hasResult?.current) {
      const data = {
        tablePlayers,
        isInsuranceTriggered,
        isResultShown,
        currentPot,
        prevPot,
        currentPlayerIndex,
      };
      setTableUpdateQueue(prev => [...prev, {data, options: null, type: 'GENERAL'}]);
    }
    const targetPlayer = tablePlayers.find(player => player && player.id === getMyPlayerId());
    updateChipsButtonState(targetPlayer?.remainingMoney, targetPlayer?.isActive);
    const isSitIn = tablePlayers.some(player => player && player.id === getMyPlayerId());
    updateEmojiButtonState(isSitIn);
    setIsEmojiButtonShown(isSitIn);
    setBasicBet(smallBlind);
    setWaitList(waitingList);

    if (roomType === ROOM_TYPE.PRIVATE) {
      setPrivateRoomExpireTime(roomExpireAt);
      setCurrentRoomMasterId(createdByPlayerId);
    } else {
      setPrivateRoomExpireTime(null);
      setCurrentRoomMasterId(null);
      setIsTimeSpanVisibile(false);
      setIsRoomMasterTimeSpanVisibile(false);
    }
    
    // Check if tournament is waiting for players on init
    // Note: The actual waiting status and timer will be set by TOURNAMENT_WAITING_STATUS_UPDATE event
    // which provides accurate player counts and cancel time
    if (roomType === 'TOURNAMENT' && tournamentStartAt) {
      const startTime = new Date(tournamentStartAt);
      const now = new Date();
      
      if (startTime <= now && !roomInfo?.gameId) {
        console.log('Tournament past start time but no game started - expecting TOURNAMENT_WAITING_STATUS_UPDATE event');
      }
    }

    if (isTournament) {
      setTournamentStartTime(tournamentStartAt);
      setTournamentId(tournamentId);
    }
  };

  const playMusicInGameRoom = useCallback((): void => {
    setAllInBgmSrc('/audio/all-in-bgm.mp3');
    setShouldMusicBePlayed(true);
  }, []);

  const delayedFunction = (fn: () => void, delayMs?: number): void => {
    setTimeout(fn, delayMs || TABLE_UPDATE_DELAY);
  };

  const gameInitHandler = (gameInitData: GameRoomInterface.GameInitResponse) => {
    console.log('gameInitHandler?.gameId', gameInitData?.gameId);
    if (gameInitData?.gameId) {
      updateGameId(gameId);
      gameIdRef.current = gameId;
      hasResult.current = false;
    }
    
    // Clear tournament waiting status when game starts
    if (isTournament) {
      console.log('Game started - clearing tournament waiting status');
      setTournamentWaitingStatus(null);
      setTournamentWaitingStatusData(null);
    }

    if (!gameInitData || !isCurrentTableInViewRef?.current) {
      setIsMyHandVisibleInBubble(true);
      return;
    }

    tableRef.current?.unhidePlayerTimer();
    const {communityCards, currentPot, prevPot, tablePlayers, currentPlayerIndex} = gameInitData;
    setAllPlayers(tablePlayers as PlayerComponent[]);
    setCommunityHands(communityCards);
    const totalPot = new BigNumber(currentPot).plus(prevPot).toNumber();
    setPotValue(totalPot);
    setPrevPot(prevPot);
    const targetPlayer = tablePlayers.find(player => player && player.id === getMyPlayerId());
    updateChipsButtonState(targetPlayer?.remainingMoney, targetPlayer?.isActive);
    // setMinBet(mb);
    // setCallAmount(ca);
    setGameResult(null);
    setGameResultOnScreen(null);
    setMyBestCombination(null);
    setWaitingTime(null);
    setIsDisableAllActions(false);
    setPlayerInActionOrder(currentPlayerIndex);
    const currentPlayer = tablePlayers.filter(player => player && player.id === getMyPlayerId());

    if (currentPlayer[0]) {
      const {hand, remainingMoney} = currentPlayer[0];
      setCurrentMoney(remainingMoney);
    }
    tableRef.current?.distributeCards();
  };

  const yourTurnHandler = (data: GameRoomInterface.YourTurnResponse) => {
    // eslint-disable-next-line no-console
    console.log('%c🎯 [GameRoom] yourTurnHandler entered', 'background:#0f0;color:#000;padding:2px 6px;font-weight:bold', {
      dataGameId: data?.gameId,
      gameIdRefCurrent: gameIdRef.current,
      isInView: isCurrentTableInViewRef?.current,
      hasResultCurrent: hasResult.current,
      availableActionsLen: data?.availableActions?.length,
      willBailByView: !isCurrentTableInViewRef?.current,
      willBailByOldGame: data?.gameId < gameIdRef.current,
    });

    if (!isCurrentTableInViewRef?.current) {
      system.setBubbleContent(tableIndex, {
        hasAlert: true,
        displayMode: 'HANDS',
        hands: data?.cards?.map(card => card),
        isMyTurn: true,
        actionDuration: data?.duration / 1000,
        expireAt: data?.expiredAt,
        isTournament,
      });
      return;
    }
    if (data?.gameId < gameIdRef.current) return;

    const {availableActions: actions, actionKey: key, expiredAt} = data;

    // console.log('data yourTurn', data);
    const myTotalMoney = data.currentMoney;
    const myMaxBet = data.maxBet < myTotalMoney ? data.maxBet : myTotalMoney;
    updateChipsButtonState(data?.currentMoney, data?.isActive);
    // setIsActive(active);
    setAvailableActions(actions);
    // setIsFolded(folded);
    setActionKey(key);
    setMaxBet(myMaxBet);
    setShortcutOptions(data.shortcutOptions);

    // Catch up if yourTurn arrived before gameInitHandler for a new hand
    // (reconnect, mid-hand join, fast tournament transitions). Otherwise the
    // stale hasResult flag keeps the buttons slid-down / disabled forever.
    if (data?.gameId > (gameIdRef.current ?? 0)) {
      gameIdRef.current = data.gameId;
    }
    hasResult.current = false;
    setShouldSlideDownButtons(false);
    // Sibling of shouldSlideDownButtons — line 3151 gates on both. Missing
    // this reset caused real action buttons to stay hidden while auto-action
    // (pre-commit) UI kept showing.
    setShouldSlideDownButtonsBroadcast(false);
    setIsDisableAllActions(false);

    // Force playerInActionOrder to us. Without this, ActionButtons keeps
    // showing auto-action UI (CALL_ANY / CHECK_FOLD chips) instead of the
    // real Fold/Call/Raise buttons whenever playerInActionHandler didn't
    // land or fired with stale data.
    const myOrder = getMyPlayer(allPlayers, getMyPlayerId())?.order;
    if (myOrder != null) {
      setPlayerInActionOrder(myOrder);
    }

    // For display insurance timer for ourselves only
    setInsuranceExpireAt(expiredAt);
  };

  const tournamentPlayerRankingHandler = (data: any) => {
    console.log('tournamentPlayerRankingHandler', data);
    setTournamentPlayerRankings(data);
  };

  const tournamentResultAnnouncementHandler = (data: any) => {
    console.log('Tournament result announcement received:', data);
    setTournamentResult({
      tournamentName: data?.tournamentName,
      result: {rank: data?.ranking, prize: data?.prize},
    });

    // Prevent empty result screen
    setTimeout(() => {
      setIsTournamentResultModalOpen(true);
    }, 500);
  };

  const tournamentRebuyInviteHandler = (data: any) => {
    console.log('tournamentRebuyInviteHandler', data);
    setIsTournamentReEntryModalOpen(true);
    setTournamentRebuyInviteData(data);
  };

  const tournamentStackHandler = (data: any) => {
    console.log('tournamentStackHandler', data);
    setTournamentStack(data);
    
    // Clear tournament waiting status when tournament stack is received
    // This means the tournament has started and is no longer waiting for players
    if (tournamentWaitingStatus) {
      console.log('Tournament stack received - clearing waiting status');
      setTournamentWaitingStatus(null);
      setTournamentWaitingStatusData(null);
    }
  };
  const tournamentThanksForJoiningHandler = (data: any) => {
    console.log('tournamentThanksForJoiningHandler', data);
    setIsTournamentThanksForJoiningModalOpen(true);
    setTournamentThanksData({
      tournamentName: data?.tournamentName || tournamentResult?.tournamentName || 'Tournament',
      tournamentId: data?.tournamentId || tournamentId
    });
  };
  const tournamentCancelHandler = (data: any) => {
    console.log('tournamentCancelHandler', data);
    console.log('Current state:', {
      isCurrentTableInView,
      isCurrentTableInViewRef: isCurrentTableInViewRef.current,
      roomNumber,
      isTableActive,
      isGameOverlayShown,
      isTournament
    });
    
    // Don't check isCurrentTableInViewRef for tournament cancel
    console.log('Setting tournament cancel modal open to true');
    setIsTournamentCancelModalOpen(true);
    const cancelData = {
      tournamentName: data?.tournamentName || tournamentResult?.tournamentName || 'Tournament',
      refundAmount: data?.refundAmount
    };
    console.log('Setting tournament cancel data:', cancelData);
    setTournamentCancelData(cancelData);
    
  };
  const tournamentWaitingForPlayersHandler = (data: any) => {
    console.log('tournamentWaitingForPlayersHandler', data);
    // Disabled: Don't show the waiting for players modal popup
    // The waiting timer will only be shown when TOURNAMENT_WAITING_STATUS_UPDATE is received
    // This ensures the timer doesn't show during early join period
    setTournamentWaitingData({
      tournamentName: data?.tournamentName || tournamentResult?.tournamentName || 'Tournament',
      currentPlayers: data?.currentPlayers || 0,
      minPlayersRequired: data?.minPlayersRequired || 0
    });
  };

  const tournamentWaitingStatusUpdateHandler = (data: any) => {
    console.log('tournamentWaitingStatusUpdateHandler', data);
    if (!isCurrentTableInViewRef?.current) {
      console.log('Skipping tournament waiting status update - not in view');
      return;
    }
    
    
    setTournamentWaitingStatusData({
      currentPlayers: data?.currentPlayers || 0,
      minPlayersRequired: data?.minPlayersRequired || 0,
      remainingPlayers: data?.remainingPlayers || 0,
      remainingTimeMinutes: data?.remainingTimeMinutes || 0,
      message: data?.message || '',
      cancelTime: data?.cancelTime || null
    });
    
    // Update the waiting status if tournament is waiting
    // Note: Backend sends lowercase status
    const status = data?.status?.toUpperCase();
    if (status === 'WAITING_ENOUGH_PLAYERS_TO_START' || 
        status === 'UPCOMING' || 
        status === 'STARTING') {
      // Preserve the actual status to differentiate between upcoming and waiting states
      setTournamentWaitingStatus(status);
    } else {
      setTournamentWaitingStatus(null);
    }
  };

  const insuranceHandler = (data: GameLogicInterface.Insurance) => {
    if (!isCurrentTableInViewRef?.current) return;

    const {isTriggered, outs, odds, winningPercentages, minPremium} = data;

    setOutCards(outs);
    setInsuranceInfo({...data});
  };

  const joinRoomErrorHandler = (data: any) => {
    setIsJoinRoomErrorVisible(true);
    if (data?.errorCode) {
      setJoinRoomErrorCode(data?.errorCode);
    }
  };

  const playerInActionHandler = data => {
    if (!isCurrentTableInViewRef?.current) return;

    setPlayerInActionOrder(data?.playerOrder);
  };

  const GAME_TYPE = {
    SHORT: 'SHORT',
  };

  const isIphoneSE = getSafe(
    () => window.screen.width === 375 && window.screen.height === 667,
    false
  );
  const isIphone13 = getSafe(
    () => window.screen.width === 390 && window.screen.height === 844,
    false
  );
  const isIphone13Mini = getSafe(
    () => window.screen.width === 375 && window.screen.height === 812,
    false
  );
  const isIphone14Pro = getSafe(
    () => window.screen.width === 393 && window.screen.height === 852,
    false
  );

  const updateChipsButtonState = (currentMoneyFromResponse, isActive) => {
    const isWithdrawChipsBtnShown =
      (tableInfo?.isAllIn || tableInfo?.gameType === GAME_TYPE.SHORT) &&
      currentMoneyFromResponse > maxBuyInRef?.current &&
      isActive;
    const isDepositChipsBtnShown = currentMoneyFromResponse < maxBuyInRef?.current && isActive;
    // console.log(
    //   'currentMoneyFromResponse',
    //   currentMoneyFromResponse,
    //   'isActive',
    //   isActive,
    //   'maxBuyInRef?.current',
    //   maxBuyInRef?.current,
    //   'isDepositChipsBtnShown',
    //   isDepositChipsBtnShown
    // );
    setIsWithdrawChipsBtnShown(isWithdrawChipsBtnShown, roomNumber);
    setIsDepositChipsBtnShown(isDepositChipsBtnShown, roomNumber);
  };

  const updateEmojiButtonState = (isSitIn: boolean) => {
    setIsEmojiBtnShown(isSitIn);
  };

  const playSoundEffect = () => {
    const handleAudioEnded = () => {
      setAudioSrc(null);
    };
    if (audioSrc && audioRef.current) {
      audioRef.current.src = audioSrc;
      // Reset the audio to start from the beginning
      // audioRef.current.currentTime = 0;
      audioRef.current.play().catch(error => {
        // console.log(' ** err in playSoundEffect() in audioRef ** ', error);
      });
      audioRef.current.addEventListener('ended', handleAudioEnded);
    }
  };

  useEffect(() => {
    if (shouldAudioBePlayed) {
      playSoundEffect();
    }
  }, [audioSrc]);

  const playVoice = () => {
    const handleVoiceEnded = () => {
      setVoiceSrc(null);
    };
    if (voiceSrc && voiceRef.current) {
      voiceRef.current.src = voiceSrc;
      // Reset the audio to start from the beginning
      // voiceRef.current.currentTime = 0;
      voiceRef.current.play().catch(error => {
        // console.error('Error playing voice:', error);
      });
      voiceRef.current.addEventListener('ended', handleVoiceEnded);
    }
  };

  useEffect(() => {
    if (shouldAudioBePlayed) {
      playVoice();
    }
  }, [voiceSrc]);

  const playCardSound = () => {
    const handleAudioEnded = () => {
      setCardSoundSrc(null);
    };
    if (cardSoundSrc && cardSoundRef.current) {
      cardSoundRef.current.src = cardSoundSrc;
      cardSoundRef.current.play().catch(error => {
        // ..
      });
      cardSoundRef.current.addEventListener('ended', handleAudioEnded);
    }
  };

  // * step 2: set card sound src
  useEffect(() => {
    if (communityHands.length === 0 || !shouldAudioBePlayed) {
      return;
    }
    setCardSoundSrc('/audio/card.mp3');
  }, [communityHands.length]);

  // * step 3: play card sound
  useEffect(() => {
    if (shouldAudioBePlayed) {
      playCardSound();
    }
  }, [cardSoundSrc]);

  const [shouldAnimationBePlayed, setShouldAnimationBePlayed] = useState<boolean>(false);
  const animationHandler = (isPlayCardFlipAnimation: boolean) => {
    // console.log('data', data);
    setShouldAnimationBePlayed(isPlayCardFlipAnimation);
  };
  // TODO all-in, only myself can hear, for the last 2 players, stop when a action is made
  const soundEffectHandler = (soundEffect: GameLogicInterface.Table['soundEffect']): void => {
    if (!soundEffect) return;

    let newVoiceSrc = silentSoundPath;
    let newAudioSrc = silentSoundPath;

    newVoiceSrc = `/audio/voice/${soundEffect.toLowerCase()}.mp3`;
    newAudioSrc = `/audio/sound-effect/${soundEffect.toLowerCase()}.mp3`;

    // console.log(' --- soundEffect --- ', soundEffect);
    setVoiceSrc(newVoiceSrc);
    setAudioSrc(newAudioSrc);
  };

  const updateGameId = gameId => {
    // console.log('updateGameId', gameId);
    setGameId(gameId);
    gameIdRef.current = gameId;
  };

  const updateTabBubbleContent = (params?: {
    actionOrder: number;
    actionExpireAt: string;
    actionDuration: number;
    pot: number;
    player: Player;
    hands: PokerComponent[];
    isMyHandVisibleInBubble: boolean;
  }) => {
    const {actionOrder, actionExpireAt, actionDuration, pot, player, hands} = params || {};
    const data: TabBubble = {
      isMyTurn: false,
      expireAt: null,
      actionDuration: null,
      hands: [],
      displayMode: null,
      isSatOut: null,
      pot: null,
      isTournament,
    };

    if (player) {
      const {isActive, isFolded, isSatOut, isTournamentSatOut} = player;
      if (!isActive) {
        data.pot = pot;
        data.displayMode = 'POT';
        data.hasAlert = false;
      } else if (isFolded) {
        data.pot = pot;
        data.displayMode = 'POT';
        data.hasAlert = false;
      } else if (isSatOut || isTournamentSatOut) {
        data.displayMode = 'SIT_OUT';
        data.isSatOut = true;
        data.hasAlert = false;
      } else if (hands.length > 0) {
        if (actionOrder === player.order) {
          data.isMyTurn = true;
          data.expireAt = actionExpireAt;
          data.actionDuration = actionDuration;
          system.setBubbleAlert(tableIndex, true);
        } else {
          data.hasAlert = false;
        }
        if (isMyHandVisibleInBubble) {
          data.hands = hands.map(card => card);
          data.displayMode = 'HANDS';
        } else {
          data.displayMode = 'POT';
          data.pot = pot;
        }
      } else {
        data.pot = 0;
        data.hasAlert = false;
        data.displayMode = 'POT';
      }
    } else {
      data.pot = pot;
      data.hasAlert = false;
      data.displayMode = 'POT';
    }
    system.setBubbleContent(tableIndex, data);
  };

  const onTableAnimationFinish = () => {
    setTableUpdateQueue(prev => prev.slice(1));
    setIsTableAnimating(false);
  };

  const tableUpdateHandler = async (
    table: GameLogicInterface.Table,
    options: {isUpdateMyHands?: boolean; omitPlayerProps?: string[]} = {isUpdateMyHands: true}
  ) => {
    try {
      const {
        communityCards,
        currentPot,
        prevPot,
        players,
        minBet: mb,
        gameId,
        callAmount: ca,
        playerInAction,
        isNewStreet,
        isCleanTable,
        soundEffect,
        isPlayCardFlipAnimation,
        buttonPosition,
        currentPlayerActionExpireAt,
        currentPlayerActionTotalDuration,
        isInsuranceTriggered,
        isResultShown,
        canStreetFinish,
        isWaitingForNextPlayerAction,
        timestamp,
      } = table;

      console.log('table', table);

      // console.log(
      //   'table update',
      //   tableInfo?.roomCode,
      //   'ref: ',
      //   isCurrentTableInViewRef?.current,
      //   'state: ',
      //   isCurrentTableInView
      // );
      if (!isDebugView) {
        if (
          (gameIdRef?.current && gameIdRef.current > gameId) ||
          prevTableStatesRef?.current?.timestamp >= timestamp
        ) {
          // Meaning a new game have started. Server returned old game because of re-join room
          onTableAnimationFinish();
          return;
        }
      }

      updateGameId(gameId);

      if (!isCurrentTableInViewRef?.current) {
        // So that the content can still update when table not in view

        const myPlayerId = getMyPlayerId();
        const myPlayer = getMyPlayer(players, myPlayerId);

        let shouldUpdatePot = false;
        let satOut = false;

        // console.log('myPlayer', myPlayer, socketId, players);
        if (!myPlayer) {
          shouldUpdatePot = true;
        } else {
          const {isActive, isFolded, isSatOut, isTournamentSatOut} = myPlayer;
          if (!isActive || isFolded || isSatOut || isTournamentSatOut) {
            shouldUpdatePot = true;
          }
          if (isSatOut || isTournamentSatOut) {
            satOut = true;
          }
        }

        if (shouldUpdatePot) {
          const totalPot = new BigNumber(currentPot).plus(prevPot).toNumber();
          system.setBubbleContent(tableIndex, {
            hasAlert: false,
            displayMode: satOut ? 'SIT_OUT' : 'POT',
            pot: totalPot,
            isTournament,
          });
        }
        // else {
        //   updateTabBubbleContent({
        //     actionDuration: currentPlayerActionTotalDuration,
        //     actionExpireAt: currentPlayerActionExpireAt,
        //     actionOrder: playerInActionOrder,
        //     pot: new BigNumber(currentPot).plus(prevPot).toNumber(),
        //     hands: myHands,
        //     player: myPlayer,
        //   });
        // }

        onTableAnimationFinish();
        return;
      }

      console.log(
        'currentExpiredAt: ',
        currentPlayerActionExpireAt,
        'prevExpiredAt: ',
        prevTableStatesRef?.current?.currentPlayerActionExpireAt
      );

      // When a player re-join room, his actionExpiredAt may slightly different from the original
      const isTimeDiffLessThanOneSecond =
        Math.abs(
          dayjs(currentPlayerActionExpireAt).diff(
            prevTableStatesRef?.current?.currentPlayerActionExpireAt,
            'millisecond',
            true
          )
        ) < 1000;

      const isMyPlayerInAction =
        (players.find(player => player && player.id === getMyPlayerId())?.order ?? null) ===
        playerInAction;
      console.log(
        'myPlayerId in tableUpdate',
        getMyPlayerId(),
        isMyPlayerInAction,
        playerInAction,
        players.find(player => player && player.id === getMyPlayerId())?.order
      );

      if (
        isEqual(
          omit(table, ['timestamp', 'currentPlayerActionExpireAt']),
          omit(prevTableStatesRef.current, ['timestamp', 'currentPlayerActionExpireAt'])
        ) &&
        isTimeDiffLessThanOneSecond
      ) {
        // Nothing has changed since last update
        // Prevent new table events interupt animations
        console.log('new table events interupt animations blocked');

        if (!isWaitingForNextPlayerAction && isMyPlayerInAction) {
          setShouldSlideDownButtonsBroadcast(false);
        }
        onTableAnimationFinish();
        return;
      }

      console.log('table update');

      prevTableStatesRef.current = table;

      if (isWaitingForNextPlayerAction) {
        setShouldSlideDownButtonsBroadcast(true);
        setTimeout(() => {
          // Prevent action button from never showing up for whatever reasons
          setShouldSlideDownButtonsBroadcast(false);
        }, 1500);
      }
      setDealerButtonPosition(buttonPosition);
      const {isUpdateMyHands} = options || {};

      animationHandler(
        (isPlayCardFlipAnimation && isNewStreet) ||
          (isOmaha &&
            tableInfo?.isAllIn &&
            communityHandsRef?.current?.length === 0 &&
            communityCards.length === 3) // Display all in Omaha animation unconditionally, avoiding BE changes
        // Handle community cards animation when table update event is triggered when other player join-room
        // (communityHandsRef?.current?.length === 0 && communityCards.length === 3) ||
        // (communityHandsRef?.current?.length > 0 &&
        //   communityCards.length > communityHandsRef?.current?.length)
      );

      // TODO @@ chips
      // playerInAction === -1 indicates game not in progress. Can update without animation delay
      if ((isNewStreet || isPlayCardFlipAnimation) && playerInAction > -1) {
        await new Promise(resolve => {
          // Wait for chips to move to in front of the player
          setTimeout(() => {
            resolve(null);
          }, CHIP_TRANSITION_DURATION);
        });

        // Avoid COLLECT_CHIP sound effect to override CALL or CHECK sound effects
        soundEffectHandler(soundEffect);

        setTimeout(() => {
          setPrevPot(prevPot);
        }, CHIP_TRANSITION_DURATION + CHIP_MOVING_DURATION);

        await new Promise(resolve => {
          setTimeout(() => {
            resolve(null);
          }, CHIP_TRANSITION_DURATION);
        });
        // console.log('isNewStreet collectChipsToPot', new Date());
        await tableRef.current?.collectAllChipsToPot();
      } else {
        soundEffectHandler(soundEffect);
        setPrevPot(prevPot);
      }
      const totalPot = new BigNumber(currentPot).plus(prevPot).toNumber();
      setPotValue(totalPot);
      // setPrevPot(prevPot);
      setMinBet(mb);
      setCallAmount(ca);
      // Avoid result disappear when updating table if someone quits during result rendering
      if (!isResultShown) {
        setCommunityHands(communityCards);
        // try {
        //   await distributeCommunityCardsOneByOne(table.communityCards);
        // } catch {
        //   setCommunityHands(table.communityCards);
        // }
        setGameResult(null);
        setGameResultOnScreen(null);

        // Wait for community cards animation to finish before setting player timer
        const BUFFER = 200;
        const delay =
          communityCards?.length === 0
            ? 0
            : communityCards.length === 3
            ? COMMUNITY_CARD_PRE_FLOP_FLIP_DELAY + BUFFER
            : COMMUNITY_CARD_POST_FLOP_FLIP_DELAY + BUFFER;

        await new Promise(resolve => {
          setTimeout(() => {
            resolve(null);
          }, delay);
        });
      }

      setCurrentPlayerActionExpireAt(currentPlayerActionExpireAt);
      setCurrentPlayerActionTotalDuration(currentPlayerActionTotalDuration);

      const targetPlayer = players.find(player => player && player.id === getMyPlayerId());
      // console.log(players);
      updatePlayersState(players, isInsuranceTriggered || isResultShown, options?.omitPlayerProps);

      updateChipsButtonState(targetPlayer?.remainingMoney, targetPlayer?.isActive);
      setPlayerInActionOrder(playerInAction);

      if (!isInsuranceTriggered) {
        setInsuranceInfo(null);
        setInsuranceExpireAt(null);
      }
      if (isCleanTable || playerInAction === -1) {
        if (isUpdateMyHands) {
          if (!isEqual(myHands, [])) {
            setMyHands([]);
          }
        }
        setIsDisableAllActions(true);
      } else {
        if (!hasResult.current) {
          setIsDisableAllActions(false);
        }
      }

      if (!isWaitingForNextPlayerAction) {
        // setTimeout to fix timer won't countdown on start game
        setTimeout(() => {
          tableRef.current?.resetPlayerTimer(
            playerInAction,
            currentPlayerActionExpireAt,
            currentPlayerActionTotalDuration
          );
        }, 10);

        setTimeout(() => {
          if (!hasResult?.current && !canStreetFinish && !isWaitingForNextPlayerAction) {
            // Prevent result screen timer flicking effect
            console.log('unhide player timer');
            tableRef.current?.unhidePlayerTimer();
          }
        }, 100);
      } else {
        tableRef.current?.hidePlayerTimer();
      }

      const isRightAfterPlayerCardsDealt = players.every(
        player =>
          !player ||
          !player.currentDecision ||
          player.currentDecision === 'BB' ||
          player.currentDecision === 'SB' ||
          player.currentDecision === 'ANTE'
      );

      let actionButtonDisplayTimeout = 0;
      if (!isWaitingForNextPlayerAction && isMyPlayerInAction) {
        actionButtonDisplayTimeout += 200;
      }
      if (isPlayCardFlipAnimation) actionButtonDisplayTimeout += 800;
      else if (isRightAfterPlayerCardsDealt) actionButtonDisplayTimeout += 1800;

      if (isPlayCardFlipAnimation) {
        // console.log('display action buttons due to card flip');
      } else if (isRightAfterPlayerCardsDealt) {
        // console.log('display action buttons due to init action');
      } else {
        // console.log('display action buttons due to table update');
      }

      await pause(actionButtonDisplayTimeout);
      if (!isWaitingForNextPlayerAction && isMyPlayerInAction && !isResultShown) {
        setShouldSlideDownButtonsBroadcast(false);

        const now = dayjs();
        const REMINDER = 3;
        const BUFFER = 1;
        const diff = dayjs(currentPlayerActionExpireAt)
          .subtract(REMINDER + BUFFER, 'second')
          .diff(now);
        const remainingDuration = dayjs(currentPlayerActionExpireAt).diff(now);

        // Clear existing timeout before setting a new one
        clearMyTurnReminderTimeouts();

        // Ding sound in the last 3 seconds or immediately if there's no 3s remaining
        myTurnSoundTimeoutRef.current = setTimeout(() => {
          // playMyTurnSound();
          setMyTurnSoundSrc('/audio/my-turn-2.mp3');
          if (NEXT_PUBLIC_RUNTIME_ENV !== 'production' && NEXT_PUBLIC_RUNTIME_ENV !== 'staging') {
            notification.info({message: 'hihi'});
          }
        }, diff);

        // Ding sound in the first 1 seconds, if remaining time is more than 6s
        if (remainingDuration > 6000) {
          myTurnSoundFirst5SecTimeoutRef.current = setTimeout(() => {
            setMyTurnSoundSrc('/audio/my-turn-2.mp3');
            if (NEXT_PUBLIC_RUNTIME_ENV !== 'production' && NEXT_PUBLIC_RUNTIME_ENV !== 'staging') {
              notification.info({message: 'first 5s'});
            }
          }, 1000);
        }
      } else {
        clearMyTurnReminderTimeouts();
      }

      console.log('myBestCombination', myBestCombinationRef.current);

      const shouldUpdateBestCombination = (prev, next) => {
        if (isNewStreet || !prev || !prev.displayValue || !prev.combinationName) {
          return true;
        }
        if (
          isCleanTable ||
          communityCards?.length === 0 ||
          !next.displayValue ||
          !next.combinationName
        ) {
          // For cleaning up
          return true;
        }
        return false;
      };

      setTimeout(() => {
        // Prevent private info after table update event. Resulting in non-updated best combination
        setMyBestCombination(prev => {
          if (shouldUpdateBestCombination(prev, myBestCombinationRef.current)) {
            return myBestCombinationRef.current;
          }
          return prev;
        });
      }, 500);

      onTableAnimationFinish();
    } catch (error) {
      onTableAnimationFinish();
    }
  };

  const distributeCommunityCardsOneByOne = communityCards => {
    return new Promise(async resolve => {
      animationHandler(true);
      const RESULT_REACTION_TIME = 0;

      console.log('communityHandsRef', communityHandsRef.current, communityCards.length);
      if (isEqual(communityHandsRef.current, communityCards)) {
        resolve(null);
      }
      if (communityCards.length - communityHandsRef.current.length === 1) {
        setCommunityHands(communityCards); // Only distribute one card, no handling
        resolve(null);
      }

      if (communityHandsRef.current.length !== communityCards.length) {
        for (
          let cardIndex = communityHandsRef.current.length, count = 1;
          cardIndex < communityCards.length;
          cardIndex += 1, count += 1
        ) {
          if (cardIndex === 0) {
            // distribute 3 cards first
            // set card index = 2 as 3 cards has been distributed
            cardIndex = 2;
            setTimeout(() => {
              setCommunityHands(communityCards.filter((_card, index) => index <= 2));
              if (cardIndex === communityCards.length - 1) {
                setTimeout(() => {
                  resolve(null);
                }, RESULT_REACTION_TIME);
              }
            }, RESULT_PAUSE_MS * count);
          } else {
            setTimeout(() => {
              const newCards = [...communityHandsRef.current, communityCards[cardIndex]];
              if (newCards.length <= 5) {
                // When table update and result update are too close, communityHandsRef might not be up to date
                setCommunityHands(newCards);
              }
              if (cardIndex === communityCards.length - 1) {
                setTimeout(() => {
                  resolve(null);
                }, RESULT_REACTION_TIME);
              }
            }, RESULT_PAUSE_MS * count);
          }
        }
      } else {
        setCommunityHands(communityCards);
        await pause(RESULT_REACTION_TIME);
        // Timeout was set because all in cause animation not showing
        resolve(null);
      }
    });
  };

  const clearMyTurnReminderTimeouts = () => {
    if (myTurnSoundTimeoutRef.current) {
      clearTimeout(myTurnSoundTimeoutRef.current);
    }
    if (myTurnSoundFirst5SecTimeoutRef.current) {
      clearTimeout(myTurnSoundFirst5SecTimeoutRef.current);
    }
  };

  const gameResultHandler = async (
    result: GameResultResponse['result'],
    players: GameResultResponse['players'],
    table: GameResultResponse['table']
  ) => {
    try {
      clearMyTurnReminderTimeouts();
      console.log('table?.gameId, gameIdRef?.current', table?.gameId, gameIdRef?.current);
      if (!isCurrentTableInViewRef?.current) {
        onTableAnimationFinish();
        return;
      }
      // Prevent result animation showing after new game started due to server delay
      if (!isDebugView && (table?.gameId < (gameIdRef?.current ?? 0) || hasResult?.current)) {
        onTableAnimationFinish();
        return;
      }
      // TODO fade out music please
      setShouldMusicBePlayed(false);
      setShouldSlideDownButtons(true);
      setIsDisableAllActions(true);
      // TODO for all in animation
      hasResult.current = true;

      setInsuranceInfo(null);
      setOutCards(null);
      setAvailableActions([]);

      if (tableRef.current) {
        console.log('result collectChipsToPot', new Date());

        tableRef.current?.hidePlayerTimer();
        // await collectAllChipsToPot won't actually have timeout for some reasons

        setTimeout(() => {
          setPrevPot(table?.prevPot);
        }, CHIP_TRANSITION_DURATION + CHIP_MOVING_DURATION);

        await pause(CHIP_TRANSITION_DURATION);
        await tableRef.current.collectAllChipsToPot();
      }

      const totalPot = new BigNumber(table?.currentPot).plus(table?.prevPot).toNumber();
      setPotValue(totalPot);

      updatePlayersState(players, true, ['remainingMoney']);

      await new Promise(resolve => {
        setTimeout(() => {
          resolve(null);
        }, 500);
      });

      try {
        // await distributeCommunityCardsOneByOne(table.communityCards);
        await new Promise(resolve => {
          animationHandler(true);
          const RESULT_REACTION_TIME = 500;

          if (communityHandsRef.current.length !== table.communityCards.length) {
            for (
              let cardIndex = communityHandsRef.current.length, count = 1;
              cardIndex < table.communityCards.length;
              cardIndex += 1, count += 1
            ) {
              if (cardIndex === 0) {
                // distribute 3 cards first
                // set card index = 2 as 3 cards has been distributed
                cardIndex = 2;
                setTimeout(() => {
                  setCommunityHands(table.communityCards.filter((_card, index) => index <= 2));
                }, RESULT_PAUSE_MS * count);
              } else {
                setTimeout(() => {
                  const newCards = [...communityHandsRef.current, table.communityCards[cardIndex]];
                  if (newCards.length <= 5) {
                    // When table update and result update are too close, communityHandsRef might not be up to date
                    setCommunityHands(newCards);
                  }
                  if (cardIndex === table.communityCards.length - 1) {
                    setTimeout(() => {
                      resolve(null);
                    }, RESULT_REACTION_TIME);
                  }
                }, RESULT_PAUSE_MS * count);
              }
            }
          } else {
            setCommunityHands(table.communityCards);
            setTimeout(() => {
              // Timeout was set because all in cause animation not showing
              resolve(null);
            }, RESULT_REACTION_TIME);
          }
        });
      } catch {
        setCommunityHands(table.communityCards);
      }

      await new Promise(resolve => {
        setTimeout(() => {
          resolve(null);
        }, 500);
      });

      if (table?.gameId < (gameIdRef?.current ?? 0)) {
        onTableAnimationFinish();
        return;
      }
      // Check again due to the setTimeouts above
      // Prevent result animation showing after new game started due to server delay

      setGameResult({result, gameId: table?.gameId, players});
      user?.getPlayerInfo();
      const targetPlayer = players.find(player => player && player.id === getMyPlayerId());
      updateChipsButtonState(targetPlayer?.remainingMoney, targetPlayer?.isActive);
      onTableAnimationFinish();
    } catch (error) {
      onTableAnimationFinish();
    }
  };

  const gameRestartHandler = restartInfo => {};

  const buyInAgainHandler = data => {
    setIsBuyInVisible(true);
    setBuyInExpiredAt(data.expiredAt);
    setMaxBuyInAmount(data.maxBuyIn);
    setBuyInToken(data.buyInToken);
    setWalletBalance(data.walletBalance);
  };

  const directGameInviteHandler = data => {
    setIsBuyInVisible(true);
  };

  const playerFoldHandler = data => {};

  const privateInfoUIUpdateHandler = (data: BestCombinationResult) => {
    try {
      // if (
      //   !myBestCombinationRef.current ||
      //   !myBestCombinationRef.current.combinationName ||
      //   !myBestCombinationRef.current.displayValue
      // ) {
      //   // Best combo UI have not been initialised, therefore setState to update UI immediately
      //   setMyBestCombination({
      //     displayValue: data?.cardValues || null,
      //     combinationName: data?.combinationName || null,
      //   });
      // }

      // Update myBestCombination UI at tableUpdateHandler
      myBestCombinationRef.current = {
        displayValue: data?.cardValues || null,
        combinationName: data?.combinationName || null,
      };
      onTableAnimationFinish();
    } catch {
      onTableAnimationFinish();
    }
  };

  const privateInfoHandler = (data: PrivateInfoResponse['data']) => {
    const {isNewGame, bestCombination, cards, availableActions, autoAction, isFolded} = data;

    // console.log(
    //   'privateInfo',
    //   'data gameId: ',
    //   data?.gameId,
    //   'gameIdRef: ',
    //   gameIdRef.current,
    //   'hasResult:',
    //   hasResult.current
    // );

    if (!isCurrentTableInViewRef?.current) {
      // So that the content can still update when table not in view

      if (isFolded || cards.length === 0) {
        // cards.length === 0 means a new game hasn't started, don't update player hands as it will be empty
        // Do nothing as totalPot is not provided, see if there's bug and decide what to do later
        // system.setBubbleContent(tableIndex, {
        //   hasAlert: false,
        //   displayMode: 'POT',
        //   pot: totalPot,
        // });
      } else {
        system.setBubbleContent(tableIndex, {
          hasAlert: false,
          displayMode: 'HANDS',
          hands: cards.map(card => card),
          isTournament,
        });
      }
      return;
    }

    if (data?.gameId < gameIdRef.current) return;

    // console.log('privateInfoHandler', data);
    // TODO: Transform combinationName

    if (!hasResult?.current) {
      // Prevent showing best possible combo before animation ends
      myBestCombinationRef.current = {
        displayValue: bestCombination?.cardValues || null,
        combinationName: bestCombination?.combinationName || null,
      };

      // const data = {
      //   cardValues: bestCombination?.cardValues || null,
      //   combinationName: bestCombination?.combinationName || null,
      // };
      // setTableUpdateQueue(prev => [...prev, {data, options: null, type: 'PRIVATE_INFO'}]);
    }

    setMyAutoAction(autoAction);

    if (!hasResult?.current || cards?.length === 0) {
      // Prevent overriding highlighted cards
      setMyHands(cards);
    }
  };

  const emojiThrowHandler = (isAnimated = false) => {
    if (!isCurrentTableInViewRef?.current) return;

    const updatedData = {
      animationFile: null,
      image: isAnimated
        ? '/upload/file/diamondItem/image/e04954bc-ef24-49ef-b431-bc4bae703277.png'
        : '/upload/file/diamondItem/image/3760180a-83e6-4a92-aec2-1b92fd66b953.png',
      playerId: 1,
      roomCode: 'DJP7',
      targetPlayerId: 0,
    };

    setStickerAnimationQueue(prev => [...prev, updatedData]);

    // setEmojiStatus({
    //   playerId: Math.floor(Math.random() * 6),
    //   targetPlayerId: Math.floor(Math.random() * 6),
    //   image: null,
    //   roomCode: null,
    // });
  };
  // TODO *** sticker ***
  const stickerHandler = (data: EmojiStatus) => {
    if (!isCurrentTableInViewRef?.current) return;

    // console.log('data in stickerHandler', data);
    const {image, playerId, targetPlayerId, roomCode, animationFile} = data;
    const updatedData = {...data, timestamp: Date.now()};

    setStickerAnimationQueue(prev => [...prev, updatedData]);
    // setEmojiStatus({
    //   image,
    //   playerId,
    //   targetPlayerId,
    //   roomCode,
    //   animationFile,
    // });
  };

  const gameRoomComponentOnAfkNotification = data => {
    console.log('AFK notification data', data);
    setForceQuitMoment(data.forceKickAt);
    setIsEmojiDrawerVisible(false);
    setIsForceQuitModalVisible(true);
  };

  const gameRoomComponentOnExpired = data => {
    console.log('private room Expired', data);
    // setIsExpiredRoomModalVisbile(true);
    setIsExtendRoomModalVisbile(false);
    setIsRoomMasterTimeSpanVisibile(false);
    setIsTimeSpanVisibile(false);
  };

  const gameRoomComponentOnRemaining = data => {
    console.log('private Room Remaining', data);
    setIsExtendRoomModalVisbile(true);
    if (extendTimerRef.current) extendTimerRef.current.showDrawer();
    if (data) {
      setExpiredTime(data.expiredAt);
    }
  };

  const gameRoomComponentOnExitRoomNotification = data => {
    exitRoom(data.roomCode);
  };

  const gameRoomComponentOnCopy = (rmNum: string) => {
    copyRoomNumber(rmNum);
  };

  const gameRoomComponentOnShare = (rmNum: string) => {
    shareLink(rmNum);
  };

  const gameRoomComponentOnClickEmoji = (rmNum: string) => {
    console.log('emoji triggered');
    setIsEmojiDrawerVisible(true);
  };

  const gameRoomComponentOnClickHistory = (rmNum: string) => {
    setIsHistoryDrawerVisible(true);
  };

  const gameRoomComponentOnClickWithdrawExtraBet = (rmNum: string) => {
    console.log('withdraw extra bet triggered');
    setIsWithdrawExtraBetVisible(true);
  };

  const gameRoomComponentOnClickAddExtraBet = (rmNum: string) => {
    console.log('add extra bet triggered');
    setIsAddExtraBetVisible(true);
  };

  const gameRoomComponentOnAddExtraBetSuccess = data => {
    console.log('add extra bet', data);
    if (data?.success) {
      setIsAddExtraBetVisible(false);
    }
  };

  const gameRoomComponentOnBuyInResp = data => {
    console.log('gameRoomComponentOnBuyInResp', data);
    if (data?.success) {
      closeBuyInDrawer();
    } else {
      notification.error({message: t('errorCodes:WS_0006')});
    }
    setIsBuyInLoading(false);
  };

  const gameRoomComponentOnSwitchToObserverResp = data => {
    if (data?.success) {
      closeBuyInDrawer();
    }
  };

  const gameRoomComponentOnTopupResp = data => {
    if (data?.success) {
      closeExtraBetDrawer();
    }
  };

  const gameRoomComponentOnWithdrawBetResp = data => {
    if (data?.success) {
      setIsWithdrawExtraBetVisible(false);
    }
  };

  const gameRoomComponentOnSetActionResult = data => {
    if (data?.status) {
      setButtonLoadingState(null);
      setShouldSlideDownButtons(true);
    }
  };

  const gameRoomComponentOnSitInResult = data => {
    if (data) {
      // console.log(' && sit in data', data);
    }
  };

  const gameRoomComponentOnSitOutResult = data => {
    if (data) {
      // console.log(' && sit out data', data);
    }
  };

  const dismissTimerModals = () => {
    setIsForceQuitModalVisible(false);
    setIsSitOutModalVisible(false);
  };

  // const gameRoomComponentOnExtendPrivateRoomResp = (rmNumber: string) => {};

  const roomNumber = tableInfo?.roomCode;
  const disconnectTable = () => {
    const data = {roomCode: roomNumber, action: ROOM_ACTION.DISCONNECT};
    console.log('disconnect table', {roomCode: roomNumber});
    return socket?.call(GAME_EVENTS_V3.EM_PLAYER_SET_ROOM_ACTION, {
      roomCode: roomNumber,
      data,
    });
  };

  const withdrawExtraBet = (): Promise<any> => {
    const data = {roomCode: roomNumber, isBetWithdraw: true};
    console.log('withdraw extra bet', {roomCode: roomNumber});
    return socket?.call(GAME_EVENTS_V3.EM_PLAYER_SET_WITHDRAW_EXTRA_BET, {
      roomCode: roomNumber,
      data,
    });
  };
  // TODO @@ buy-in bug
  const addExtraBet = useCallback(
    (baseObject: {base: number}): Promise<any> => {
      const data = {roomCode: roomNumber, addExtraBetAmount: baseObject.base};
      console.log('add extra bet', {roomCode: roomNumber});
      return socket?.call(GAME_EVENTS_V3.EM_PLAYER_ADD_EXTRA_BET, {
        roomCode: roomNumber,
        data,
      });
    },
    [roomNumber, socket, GAME_EVENTS_V3.EM_PLAYER_ADD_EXTRA_BET]
  );

  const fireTableAction = (actionStr: 'QUIT' | 'SIT_OUT' | 'SIT_IN') => {
    let action;
    if (actionStr === 'QUIT') {
      action = TABLE_ACTIONS.EXIT_TABLE;
    } else if (actionStr === 'SIT_IN') {
      action = TABLE_ACTIONS.SIT_IN;
    } else if (actionStr === 'SIT_OUT') {
      action = TABLE_ACTIONS.SIT_OUT;
    }

    const data = {roomCode: roomNumber, action};
    return socket?.call(GAME_EVENTS_V3.EM_PLAYER_SET_TABLE_ACTION, {
      roomCode: roomNumber,
      data,
    });
  };

  const quitTable = (): Promise<any> => {
    setIsSitOutModalVisible(false);
    return fireTableAction('QUIT');
  };

  const sitOut = (): Promise<any> => {
    if (isTournament) {
      // TODO: Tournament sit out
      setIsSitOutTournamentWarningVisible(true);
      return;
    }
    return fireTableAction('SIT_OUT');
  };

  const sitIn = (): Promise<any> => {
    if (isTournament) {
      // TODO: Tournament sit in
      return fireTableAction('SIT_IN');
    }
    return fireTableAction('SIT_IN');
  };

  const sitOutPopUp = (data: SitOutResponse['data']): void => {
    console.log('sit out notification data', data);
    setForceQuitMoment(data.forceKickAt);
    setIsSitOutModalVisible(true);
  };

  const sitOutKick = (): void => {
    setIsSitOutModalVisible(false);
    // double check if refreshJoinedRoom is needed
    user?.refreshJoinedRoom();
  };

  const buyInExpiredHandler = (): void => {
    setIsBuyInVisible(false);
  };

  const isValidTable = roomNumber && encryptionKey;

  const reconnect = async () => {
    const target = user.joinedRooms?.find(room => room?.roomCode === roomNumber);
    dismissTimerModals();
    if (!isDebugView && target) {
      await socket?.call(GAME_EVENTS_V3.JOIN_ROOM, await getJoinRoomParams());
    }
  };

  // const handleVisibilityChange = () => {
  //   if (isValidTable) {
  //     const visibility = document.visibilityState;
  //     if (visibility === 'hidden') {
  //       console.log('not visible');
  //       disconnectTable();
  //       setIsReconnectModalVisible(true);
  //     } else if (visibility === 'visible') {
  //       // TODO: Prevent this in PC web
  //       reconnect();
  //     }
  //   } else {
  //     setIsReconnectModalVisible(false);
  //   }
  // };

  const getJoinRoomParams = async () => {
    let geolocation = null;
    // Get geolocation before joining room
    try {
      const position = await new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject(new Error('Geolocation not supported'));
        }
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });

      // Add coordinates to room join data
      if (position?.coords) {
        geolocation = {
          latitude: position?.coords?.latitude,
          longitude: position?.coords.longitude,
        };
      }
    } catch (error) {
      let errorMessageKey;
      switch (error.code) {
        case GeolocationPositionError.PERMISSION_DENIED:
          errorMessageKey = 'LOCATION_CHECKING_FAILED.PERMISSION_DENIED';
          break;
        case GeolocationPositionError.POSITION_UNAVAILABLE:
          errorMessageKey = 'LOCATION_CHECKING_FAILED.POSITION_UNAVAILABLE';
          break;
        case GeolocationPositionError.TIMEOUT:
          errorMessageKey = 'LOCATION_CHECKING_FAILED.TIMEOUT';
          break;
        default:
          errorMessageKey = 'LOCATION_CHECKING_FAILED.UNKNOWN';
      }
      console.warn('Failed to get geolocation:', error);
      // notification.error({
      //   message: t(`errorCodes:${errorMessageKey}`),
      // });
    }

    console.log('geolocation', geolocation);

    return {
      roomCode: tableInfo?.roomCode,
      username: user?.getPlayerDisplayName() || '',
      token: user?.getPlayerToken(),
      id: user?.getPlayerId(),
      isObserver: tableInfo?.isObserver || false,

      // Pass geolocation property only if it get be retrieved
      ...(geolocation && {gps: geolocation}),
    };
  };

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;
    if (isDebug) {
      notification.info({message: userAgent});
    }
    if (
      userAgent.includes('MetaMaskMobile') ||
      userAgent.includes('OKApp') ||
      userAgent.includes('BMP') ||
      userAgent.includes('Trust') ||
      userAgent.includes('Coinbase')
    ) {
      if (isDebug) {
        notification.success({message: 'In-app browser detected'});
      }
      setIsInAppBrowser(true);
    } else {
      setIsInAppBrowser(false);
    }
  }, []);

  useEffect(() => {
    const joinRoom = async () => {
      const roomNumber = tableInfo?.roomCode;
      // console.log('roomNumber effect', roomNumber, tableInfo);
      if (isDebugView || !roomNumber || roomNumber === '' || !encryptionKey) {
        // alert('Missing room number');
      } else if (isCurrentTableInView) {
        // eslint-disable-next-line no-lonely-if
        socket?.call(GAME_EVENTS_V3.JOIN_ROOM, await getJoinRoomParams());
      }
      // document.addEventListener('visibilitychange', handleVisibilityChange);
    };

    // Wait for WS connection to establish in case user refresh mid-game
    setTimeout(() => {
      joinRoom();
    }, 500);
    // return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [tableInfo, encryptionKey, socket?.client, isDebugView, isCurrentTableInView]);

  const myPlayerId = getMyPlayerId();
  const myPlayer = getMyPlayer(allPlayers, myPlayerId);
  const myPlayerOrder = myPlayer?.order ?? -1;

  // const {setIsResizeLoading} = useContext(ResizeLoadingContext);

  const tournamentContextValue: TournamentContextInterface = useMemo(() => {
    const {ante, bigBlind, smallBlind, nextAnte, nextBigBlind, nextSmallBlind, nextUpdateAt} =
      tournamentStack || {};

    return {
      isTournament,
      currentSmallBlind: smallBlind,
      currentBigBlind: bigBlind,
      nextSmallBlind,
      nextBigBlind,
      nextBlindAt: isDebugView
        ? new Date(Date.now() + 3 * 60 * 1000).toISOString()
        : new Date(nextUpdateAt ?? null).toISOString(),
      playerRankings: tournamentPlayerRankings,
      tournamentStartTime: isDebugView
        ? new Date(Date.now() + 0.2 * 60 * 1000).toISOString()
        : tournamentStartTime,
      tournamentId,
      tournamentWaitingStatus,
      tournamentWaitingStatusData,
    };
  }, [isTournament, tournamentPlayerRankings, tournamentStartTime, tournamentId, tournamentWaitingStatus, tournamentWaitingStatusData, tournamentStack]);

  const tabBubbleHandVisibleContextValue: TabBubbleHandVisibleContextInterface = useMemo(
    () => ({
      setIsMyHandVisibleInBubble,
    }),
    [setIsMyHandVisibleInBubble]
  );

  const positionContextValue: PositionContextInterface = useMemo(
    () => ({
      updateComponentPosition: (
        componentId: string,
        newTop: number,
        newRight: number,
        newBottom: number,
        newLeft: number
      ) => {
        if (
          !isEqual(componentsPositions[componentId], {
            top: newTop,
            right: newRight,
            bottom: newBottom,
            left: newLeft,
          })
        ) {
          setComponentsPositions(prev => {
            return {
              ...prev,
              [componentId]: {
                top: newTop,
                right: newRight,
                bottom: newBottom,
                left: newLeft,
              },
            };
          });
        }
      },
      componentsPositions,
      scaleUpValue,
      updateScaleUpValue: (newValue: number) => {
        if (newValue !== scaleUpValue) {
          setScaleUpValue(newValue);
          // setTimeout(() => {
          //   setIsResizeLoading(false);
          // }, 1000);
        }
      },
      playerIconCenterPositions,
      updatePlayerIconCenterPositions: array => {
        if (!isEqual(playerIconCenterPositions, array)) {
          setPlayerIconCenterPositions(array);
        }
      },
      playerChipPlacementPosition: playerChipPlacement,
      updatePlayerChipPlacementPosition: (index: number, position: AbsolutePosition) => {
        // console.log(
        //   'update playerChip pos',
        //   !isEqual(playerChipPlacement?.[index], position),
        //   index,
        //   position,
        //   playerChipPlacement
        // );
        if (!isEqual(playerChipPlacement?.[index], position)) {
          setPlayerChipPlacement(prev => {
            return prev.map((prevPos, prevIndex) => {
              if (prevIndex === index) {
                return position;
              }
              return prevPos;
            });
          });
        }
      },
    }),
    [componentsPositions, playerChipPlacement, scaleUpValue, playerIconCenterPositions]
  );
  const emojiContextValue: EmojiContextInterface = useMemo(
    () => ({
      onClickEmoji: ({diamondItemId, image}) => {
        emojiToBeFired.current = {diamondItemId, image};
      },
      OnCancelShootEmoji: () => {
        setEmojiStatus(null);
      },
      shootEmoji: async (playerId, targetPlayerId) => {
        const {diamondItemId} = emojiToBeFired.current;
        const data = {
          playerId,
          targetPlayerId,
          diamondItemId,
          roomCode: roomNumber,
        };
        // TODO: Move cb to WS
        await socket?.call(GAME_EVENTS_V3.EM_PLAYER_SEND_STICKER, {
          roomCode: roomNumber,
          data,
        });
        user.refreshPlayerInfo();
        // refresh the amount of emojis owned by user
        getItemList(user?.getPlayerToken());
      },
      emojiStatus: {
        playerId: emojiStatus?.playerId,
        targetPlayerId: emojiStatus?.targetPlayerId,
        image: emojiStatus?.image,
        roomCode: emojiStatus?.roomCode,
      },
      resetEmojiStatus: () => {
        setEmojiStatus(null);
      },
      toggleStickerDrawerVisibility: (value: boolean) => {
        // refresh the amount of emojis owned by user
        getItemList(user?.getPlayerToken());
        setIsEmojiDrawerVisible(value);
      },
      setSenderId: (senderId: number) => {
        setEmojiSenderId(senderId);
      },
      setReceiverId: (receiverId: number) => {
        setEmojiReceiverId(receiverId);
      },
      emojiReceiverId,
      emojiSenderId,
      isEmojiSending,
      setIsEmojiSendingByContext: (value: boolean) => {
        setIsEmojiSending(value);
      },
      isEmojiButtonShown,
    }),
    [
      emojiStatus,
      myPlayerOrder,
      isEmojiDrawerVisible,
      emojiSenderId,
      emojiReceiverId,
      isEmojiSending,
      isEmojiButtonShown,
    ]
  );

  const playersWithOriginalIndex = useMemo(() => {
    return allPlayers.map((player, index) => {
      return {...player, originalIndex: index};
    });
  }, [allPlayers]);

  const setTableMessageTimeout = (messageId: RoomMessage) => {
    setRoomMessage(messageId);
    tableMessageTimeout.current = setTimeout(() => {
      setRoomMessage(null);
    }, TABLE_MESSAGE_DURATION_MS);
  };

  const copyRoomNumber = (rmNum: string): void => {
    copyTextToClipboard(rmNum);
    setTableMessageTimeout(RoomMessage.COPY_ROOM_CODE);
  };

  const shareLink = (rnNum: string): void => {
    const link = `${window.location.origin}/join-with-link?roomCode=${rnNum}&isAllIn=${tableInfo?.isAllIn}&isObserver=false`;
    copyTextToClipboard(link);
    setTableMessageTimeout(RoomMessage.SHARE_LINK);
  };

  const exitRoom = (roomCode: string) => {
    setIsForceQuitModalVisible(false);
    user.removeJoinedRoom(roomCode);
    resetRoom();
    // * remove currentRoom query
    router.replace(
      {
        pathname: '/home',
      },
      undefined,
      {shallow: true}
    );
  };

  const displayTableMessage = (): JSX.Element => {
    if (roomMessage === RoomMessage.COPY_ROOM_CODE)
      return (
        <div className={classes.tableMessage}>
          {t('you_have_copied_room_code', {value: roomNumber})}
        </div>
      );
    if (roomMessage === RoomMessage.SHARE_LINK)
      return <div className={classes.tableMessage}>{t('link_copied')}</div>;
    return null;
  };

  useEffect(() => {
    if (
      currentRoomMasterId !== null &&
      typeof currentRoomMasterId !== 'undefined' &&
      currentRoomMasterId === user?.getPlayerId()
    ) {
      setIsRoomMasterTimeSpanVisibile(true);
      setIsTimeSpanVisibile(false);
    } else if (currentRoomMasterId) {
      setIsTimeSpanVisibile(true);
      setIsRoomMasterTimeSpanVisibile(false);
    }
  }, [privateRoomExpireTime, currentRoomMasterId]);

  const calculateBuyInMinAmount = (): number => {
    const maxBuyInInBB = new BigNumber(maxBuyIn);
    const currentMoneyInBB = new BigNumber(currentMoney);
    const buyInMaxAmountInNumber = maxBuyInInBB.minus(currentMoneyInBB).toNumber();

    if (isNaN(buyInMaxAmountInNumber)) {
      return 0;
    }

    const buyInMin = Math.min(bigBlind, buyInMaxAmountInNumber);

    if (buyInMin === buyInMaxAmountInNumber) return 0;
    return buyInMin;
  };

  const calculateBuyInMaxAmount = (maxBuyIn: number, currentMoney: number): number => {
    const maxBuyInInBB = new BigNumber(maxBuyIn);
    const currentMoneyInBB = new BigNumber(currentMoney);
    const buyInMaxAmountInNumber = maxBuyInInBB.minus(currentMoneyInBB).toNumber();

    if (isNaN(buyInMaxAmountInNumber)) {
      return 0;
    }

    return buyInMaxAmountInNumber;
  };

  const unlockAudio = () => {
    if (!isAudioUnlockedRef.current) {
      isAudioUnlockedRef.current = true;
      setCardSoundSrc('/audio/silence.mp3');
      setVoiceSrc('/audio/silence.mp3');
      setAudioSrc('/audio/silence.mp3');
      setWinnerSoundSrc('/audio/silence.mp3');
      setMyTurnSoundSrc('/audio/silence.mp3');
      setAllInBgmSrc('/audio/silence.mp3');
    }
  };

  const buyInCallback = useCallback(
    position => {
      if (encryptionKey) {
        const data = {
          action: TABLE_ACTIONS.JOIN_TABLE,
          seatIndex: position,
        };
        socket?.call(GAME_EVENTS_V3.EM_PLAYER_SET_TABLE_ACTION, {
          roomCode: roomNumber,
          data,
        });
        setIsForceQuitModalVisible(false);
      }
    },
    [encryptionKey, socket, GAME_EVENTS_V3.EM_PLAYER_SET_TABLE_ACTION, roomNumber]
  );

  const buyInFinishCallback = useCallback(
    baseObject => {
      // * step 1: handshake with safari, otherwise safari will block the audio
      setCardSoundSrc('/audio/silence.mp3');
      setIsBuyInLoading(true);
      setAudioSrc('/audio/press.mp3');
      setVoiceSrc('/audio/silence.mp3');
      setWinnerSoundSrc('/audio/silence.mp3');
      setMyTurnSoundSrc('/audio/silence.mp3');
      setAllInBgmSrc('/audio/silence.mp3');
      const data = {...baseObject, roomCode: roomNumber, buyInToken};
      return socket?.call(GAME_EVENTS_V3.EM_PLAYER_SET_BASE, {
        roomCode: roomNumber,
        data,
      });
    },
    [socket, roomNumber, encryptionKey, GAME_EVENTS_V3.EM_PLAYER_SET_BASE, buyInToken]
  );

  const buyInCancelCallback = useCallback(() => {
    // TODO: Move callback to WS
    const data = {roomCode: roomNumber, action: TABLE_ACTIONS.SWITCH_TO_OBSERVER};
    console.log('cancel buy in table', {roomCode: roomNumber});
    return socket?.call(GAME_EVENTS_V3.EM_PLAYER_SET_TABLE_ACTION, {
      roomCode: roomNumber,
      data,
    });
  }, [roomNumber, encryptionKey, socket, GAME_EVENTS_V3.EM_PLAYER_SET_TABLE_ACTION]);

  const closeDrawer = useCallback(() => setIsBuyInVisible(false), []);

  const closeBuyInDrawer = useCallback(() => setIsBuyInVisible(false), []);

  const closeExtraBetDrawer = useCallback(() => setIsAddExtraBetVisible(false), []);

  const onRejoinRoom = useCallback(() => {
    const data = {
      action: TABLE_ACTIONS.JOIN_TABLE,
    };
    try {
      socket?.call(GAME_EVENTS_V3.EM_PLAYER_SET_TABLE_ACTION, {
        roomCode: roomNumber,
        data,
      });
      setIsForceQuitModalVisible(false);
    } catch {
      console.log('set table action failed');
    }
  }, [roomNumber, encryptionKey, socket, GAME_EVENTS_V3.EM_PLAYER_SET_TABLE_ACTION]);

  const closeEmojiDrawer = useCallback(() => setIsEmojiDrawerVisible(false), []);

  const closeHistoryDrawer = useCallback(() => setIsHistoryDrawerVisible(false), []);

  const setTableActionCallback = useCallback(
    async params => {
      const data = {...params, actionKey, roomCode: roomNumber};
      console.log('set table action', {...params, actionKey, roomCode: roomNumber});
      const resp: any = await socket?.call(GAME_EVENTS_V3.EM_PLAYER_SET_TABLE_ACTION, {
        roomCode: roomNumber,
        data,
      });
      return resp;
    },
    [encryptionKey, socket, roomNumber, GAME_EVENTS_V3.EM_PLAYER_SET_TABLE_ACTION, actionKey]
  );

  // TODO: Move cb to WS
  const setPlayerActionCallback = useCallback(
    async params => {
      clearMyTurnReminderTimeouts();
      unlockAudio();
      const data = {...params, actionKey, roomCode: roomNumber, value: Number(params.value)};
      // console.log(' ** setPlayerActionCallback - params', params);
      setButtonLoadingState(params);

      console.log('begin hiding player timer');
      tableRef?.current.hidePlayerTimer();
      if (isDebugView) {
        setTimeout(() => {
          setButtonLoadingState(null);
        }, 2000);
      }

      // console.log('set action', {...params, actionKey, roomCode: roomNumber});
      // console.log(
      //   'set action ios debugger',
      //   `actionKey: ${actionKey} | roomCode: ${roomNumber} | encryptionKey: ${encryptionKey}`
      // );
      const resp: any = await socket?.call(GAME_EVENTS_V3.EM_PLAYER_SET_ACTION, {
        roomCode: roomNumber,
        data,
      });
      return resp;
    },
    [encryptionKey, roomNumber, GAME_EVENTS_V3.EM_PLAYER_SET_ACTION, actionKey, socket]
  );

  const currenRoomCode = router.query?.currentRoom;

  useEffect(() => {
    const backToCurrentRoom = () => {
      const performanceEntries = performance.getEntriesByType('navigation');
      const {type} = performanceEntries[0] as PerformanceNavigationTiming;
      const currentRoomIndex = user?.joinedRooms.findIndex(
        room => room?.roomCode === currenRoomCode
      );

      if (performanceEntries.length > 0 && type === 'reload' && currentRoomIndex > -1) {
        system?.showGameOverlay();
        system?.setActiveTableIndex(currentRoomIndex);
      }
    };

    backToCurrentRoom();
  }, [user?.joinedRooms, currenRoomCode]);

  // if (!isCurrentTableInView) {
  //   return <div className={classes.singleTableContainer} />;
  // }

  const shouldDisplayActionButton = !shouldSlideDownButtons && !shouldSlideDownButtonsBroadcast;
  if (typeof window !== 'undefined' && availableActions?.length > 0) {
    // eslint-disable-next-line no-console
    console.log('%c🎯 [GameRoom] render gate (actions present)', 'background:#09f;color:#fff;padding:2px 6px;font-weight:bold', {
      shouldDisplayActionButton,
      shouldSlideDownButtons,
      shouldSlideDownButtonsBroadcast,
      isDisableAllActions,
      availableActionsLen: availableActions?.length,
      playerInActionOrder,
      myPlayerOrder: myPlayer?.order,
      hasResultCurrent: hasResult.current,
    });
  }
  // console.log(
  //   'shouldSlideDownButtons, shouldSlideDownButtonsBroadcast',
  //   shouldSlideDownButtons,
  //   shouldSlideDownButtonsBroadcast,
  //   'shouldHide: ',
  //   !shouldDisplayActionButton
  // );

  const renderPlayerPosition = () => {
    return playerIconCenterPositions
      ?.filter((_v, index) => index === 0)
      ?.map(pos => {
        return (
          <span>
            {Math.floor(pos?.x)} / {Math.floor(pos?.y)}
          </span>
        );
      });
  };

  const handleCopyClick = async () => {
    try {
      await copyTextToClipboard(JSON.stringify(getDebugPrintItems()));
      notification.success({message: t('common:copy_success')});
    } catch (error) {
      console.error('Error copying text:', error);
    }
  };

  const formatJSONOutput = obj => {
    return JSON.stringify(obj, null, 0);
  };

  const countdownRenderer = ({minutes, seconds, isLarge}) => {
    const style = isLarge
      ? {
          color: 'white',
          fontSize: 32,
          fontFamily: 'Avenir Next Condensed',
          fontWeight: 'bold',
        }
      : {
          color: 'white',
          fontSize: 15,
          fontFamily: 'Avenir Next Condensed',
          fontWeight: 'bold',
        };
    return <span style={style}>{`${zeroPad(minutes)}:${zeroPad(seconds)}`}</span>;
  };

  const playersToString = (players: Player[]) => {
    if (!players) return null;

    return formatJSONOutput(players);
  };

  const getDebugPrintItems = (): DescriptionsItemType[] => {
    const bestCombinationString = {
      cards: formatJSONOutput(myBestCombination?.cards),
      combinationName: myBestCombination?.combinationName,
      displayValue: myBestCombination?.displayValue,
    };

    const gameResultPotsString = gameResult?.result
      ? gameResult.result.map(result => {
          const obj = {
            ...result,
            potWinnersIds: result.potWinnerIds.toString(),
            selectedCards: result.selectedCards.map(hand => formatJSONOutput(hand)),
            selectedCardsByPlayerId: Object.entries(result.selectedCardsByPlayerId).map(value => {
              const [key, val] = value;
              return {[key]: val.map(hand => formatJSONOutput(hand))};
            }),
          };
          return obj;
        })
      : null;

    const gameResultString = {
      result: gameResultPotsString,
      gameId: gameResult?.gameId,
      players: playersToString(gameResult?.players),
    };

    return [
      {
        label: 'myHands',
        children: formatJSONOutput(myHands),
      },
      {
        label: 'communityHands',
        children: formatJSONOutput(communityHands),
      },
      {
        label: 'availableActions',
        children: availableActions.toString(),
      },
      {
        label: 'playerInActionOrder',
        children: playerInActionOrder,
      },
      {
        label: 'basicBet(SB)',
        children: basicBet,
      },
      {
        label: 'potValue',
        children: potValue,
      },
      {
        label: 'prevPot',
        children: prevPot,
      },
      {label: 'roomCode', children: roomNumber},
      {
        label: 'gameId',
        children: gameId,
      },
      {
        label: 'myBestCombination',
        children: formatJSONOutput(bestCombinationString),
      },
      {
        label: 'minBet',
        children: minBet,
      },
      {
        label: 'maxBet',
        children: maxBet,
      },
      {
        label: 'callAmount',
        children: callAmount,
      },
      {
        label: 'forceQuitMoment',
        children: forceQuitMoment,
      },
      {
        label: 'shortcutOptions',
        children: formatJSONOutput(shortcutOptions),
      },
      {
        label: 'componentsPosition',
        children: formatJSONOutput(componentsPositions),
      },
      {
        label: 'playerIconCenterPositions',
        children: formatJSONOutput(playerIconCenterPositions),
      },
      {
        label: 'playerChipPlacement',
        children: formatJSONOutput(playerChipPlacement),
      },
      {
        label: 'scaleUpValue',
        children: scaleUpValue,
      },
      {
        label: 'dealerButtonPosition',
        children: dealerButtonPosition,
      },
      {
        label: 'shouldSlideDownButtons',
        children: shouldSlideDownButtons,
      },
      {
        label: 'shouldSlideDownButtonsBroadcast',
        children: shouldSlideDownButtonsBroadcast,
      },
      {
        label: 'tableIndex',
        children: tableIndex,
      },
      {
        label: 'tableInfo',
        children: formatJSONOutput(tableInfo),
      },

      {
        label: 'gameResult',
        children: formatJSONOutput(gameResultString),
      },
      {
        label: 'allPlayers',
        children: playersToString(allPlayers),
      },
    ];
  };

  return (
    <div className={classes.singleTableContainer}>
      {/* <div
        className={classNames(classes.gameInfoContainer, {
          isInAppBrowser,
          [classes.hidden]: NEXT_PUBLIC_RUNTIME_ENV === 'production',
          [classes.hiddenClickable]: NEXT_PUBLIC_RUNTIME_ENV === 'production',
        })}
        onClick={() => {
          printDebugCount.current += 1;
          setTimeout(() => {
            console.log('reset printDebugCount');
            printDebugCount.current = 0;
          }, 3000);
          if (printDebugCount.current > 0 && printDebugCount.current % 3 === 0) {
            setDebugPrintItems(getDebugPrintItems());
            setIsDebugPrintVisible(true);
          }
        }}
      >
        <div>Room code</div>
        <div>{roomNumber}</div>
        <div>Game ID</div>
        <div>{gameId}</div>
        <div>Player pos x/y</div>
        <div>{renderPlayerPosition()}</div>
        <div>Chip collect pos</div>
        <div>
          {componentsPositions?.chips?.top} / {componentsPositions?.chips?.left}
        </div>
        <div>Player Chip Placement pos</div>
        <div>
          {playerChipPlacement?.[0]?.yCenter} / {playerChipPlacement?.[0]?.xCenter}
        </div>
      </div> */}
      <div className={classes.container}>
        <section className={classes.canvasArea}>
          <EmojiContext.Provider value={emojiContextValue}>
            <PositionContext.Provider value={positionContextValue}>
              <CanvasArea
                isCanvasMuted={isGameRoomMuted}
                players={allPlayers}
                handleStickerComplete={handleStickerComplete}
                stickersDataList={emojiList}
                stickerQueue={stickerAnimationQueue}
              />
            </PositionContext.Provider>
          </EmojiContext.Provider>
        </section>
        <CustomPopup
          title={t('please_wait_until_connected')}
          open={isReconnectModalVisible}
          maskClosable={false}
          closable={false}
          width={200}
          centered
        >
          <Spin indicator={spinIcon} className={classes.connectionSpinContainer} />
        </CustomPopup>
        {isDebugView ? (
          <div
            style={{
              position: 'absolute',
              display: 'inline-flex',
              flexDirection: 'column',
              top: '-10%',
              zIndex: 100,
              opacity: 0.3,
            }}
          >
            <Button
              className={classes.debugButton}
              onClick={() => {
                if (isDebugView) {
                  if (communityHands && communityHands.length === 5) {
                    setCommunityHands([]);
                    setGameResult(null);
                    setGameResultOnScreen(null);
                  } else if (communityHands.length === 3) {
                    setCommunityHands(mockCommunityCard.filter((_c, index) => index < 4));
                  } else if (communityHands.length === 4) {
                    setCommunityHands(mockCommunityCard.filter((_c, index) => index < 5));
                    setGameResult(getMockResult({gameType: tableInfo?.gameType}));
                  } else {
                    setCommunityHands(mockCommunityCard.filter((_c, index) => index < 3));
                  }
                }
              }}
            >
              deal cards
            </Button>
            <Button
              className={classes.debugButton}
              onClick={() => {
                if (isDebugView) {
                  const mockPlayers2: Array<Player> = [];
                  for (let iii = 0; iii < 6; iii += 1) {
                    const player = getMockPlayer(iii, isOmaha);
                    player.remainingMoney += Math.floor(Math.random() * 10);
                    player.currentBet = Math.floor(Math.random() * 10);
                    mockPlayers2.push(player);
                  }
                  updatePlayersState(mockPlayers2);
                  tableRef.current.collectAllChipsToPot();
                }
              }}
            >
              collect chips
            </Button>
            <Button
              className={classes.debugButton}
              onClick={() => {
                setPotValue(100);
                // TODO @@ chips effect
                tableRef.current.moveChipsToPlayers([3984, 3859]);
              }}
            >
              move chip to player
            </Button>
            <Button
              className={classes.debugButton}
              onClick={() => {
                if (isDebugView) {
                  emojiThrowHandler();
                }
              }}
            >
              emoji
            </Button>
            <Button
              className={classes.debugButton}
              onClick={() => {
                if (isDebugView) {
                  emojiThrowHandler(true);
                }
              }}
            >
              animated emoji
            </Button>
            <Button
              className={classes.debugButton}
              onClick={() => {
                if (isDebugView) {
                  setIsRegularTable(!isRegularTable);
                }
              }}
            >
              change table
            </Button>
            <Button
              className={classes.debugButton}
              onClick={() => {
                setDealerButtonPosition(dealerButtonPosition => {
                  if (tableInfo?.isAllIn) {
                    return (dealerButtonPosition + 1) % 4;
                  }
                  return (dealerButtonPosition + 1) % 6;
                });
              }}
            >
              dealer position
            </Button>
            <Button
              className={classes.debugButton}
              onClick={() => {
                setMockTable();
              }}
            >
              set table players
            </Button>
            <Button
              className={classes.debugButton}
              onClick={() => {
                resetRoom();
              }}
            >
              remove players
            </Button>
            <Button
              className={classes.debugButton}
              onClick={() => {
                setTournamentResult({
                  tournamentName: 'Test Tournament',
                  result: {
                    rank: 1,
                    prize: 1000,
                  },
                });
                setTimeout(() => {
                  setIsTournamentResultModalOpen(true);
                }, 500);
              }}
            >
              show tournament modal
            </Button>
            {/* <Button
              className={classes.debugButton}
              onClick={async () => {
                if (isDebugView) {
                  const mockPlayers2: Array<Player> = [];

                  await Promise.all(
                    Array.from({length: 6}, async (_, iii) => {
                      const player = getMockPlayer(iii, false);
                      // player.isDisconnected = true;
                      player.handLength = 0;

                      await new Promise(resolve => setTimeout(resolve, 2000));

                      player.handLength = 2;

                      console.log(' @@', mockPlayers2);
                      mockPlayers2.push(player);
                    })
                  );

                  updatePlayersState(mockPlayers2);
                }
              }}
            >
              test{' '}
            </Button> */}
          </div>
        ) : null}

        <TournamentContext.Provider value={tournamentContextValue}>
          <section
            className={classNames(classes.tableAreaSection, {
              isIphoneSE,
              isIphone13,
              isIphone13Mini,
              isIphone14Pro,
              isDebug,
              isInAppBrowser,
            })}
          >
            {displayTableMessage()}
            <PositionContext.Provider value={positionContextValue}>
              <EmojiContext.Provider value={emojiContextValue}>
                <TabBubbleHandVisibleContext.Provider value={tabBubbleHandVisibleContextValue}>
                  <TableAreaMobile
                    isCurrentTableInView={isCurrentTableInView}
                    tableIndex={tableIndex}
                    myHands={myHands}
                    myBestCombination={myBestCombination}
                    roomType={gameRoomType}
                    shouldCardsAnimationBePlayed={shouldAnimationBePlayed}
                    areActionsDisabled={isDisableAllActions}
                    actionTime={actionTime}
                    players={playersWithOriginalIndex}
                    playerInActionOrder={playerInActionOrder}
                    communityHands={communityHands}
                    outCards={outCards}
                    pot={potValue}
                    prevPot={prevPot}
                    gameResultOnScreen={gameResultOnScreen}
                    ref={tableRef}
                    waitingTime={waitingTime}
                    gameMode={tableInfo?.gameType}
                    isAllIn={tableInfo?.isAllIn}
                    roomCode={roomNumber}
                    buyInCallback={buyInCallback}
                    insuranceInfo={insuranceInfo}
                    dealerButtonPositionFromGameRoom={dealerButtonPosition}
                  />
                </TabBubbleHandVisibleContext.Provider>
              </EmojiContext.Provider>
            </PositionContext.Provider>
          </section>

          {isTournament && myPlayer?.isTournamentSatOut && (
            <Button
              className={classes.transparentButton}
              onClick={() => {
                sitIn();
              }}
            >
              <ContinueIcon width={16} height={16} /> <span>{t('sit_in')}</span>
            </Button>
          )}

          {/* <Button
          style={{position: 'absolute', zIndex: 144, top: '50%', left: '50%'}}
          onClick={() => {
            setCardSoundSrc('/audio/silence.mp3');
            setVoiceSrc('/audio/silence.mp3');
            setAudioSrc('/audio/silence.mp3');
            setWinnerSoundSrc('/audio/silence.mp3');
            setMyTurnSoundSrc('/audio/silence.mp3');
          }}
        >
          unlock audio
        </Button> */}

          <audio src={audioSrc} ref={audioRef} />
          <audio src={voiceSrc} ref={voiceRef} />
          <audio src={allInBgmSrc} ref={allInBackgroundMusicAudioRef} />
          <audio src={winnerSoundSrc} ref={winnerSoundEffectRef} />
          <audio src={cardSoundSrc} ref={cardSoundRef} />
          <audio src={myTurnSoundSrc} ref={myTurnSoundEffectRef} />

          {myPlayer ? (
            // * slide down animation can be set here if button loading state is not needed
            <section
              className={classNames(classes.actionButtonSection, {
                // [classes.slideDownAnimation]:
                // buttonLoadingState?.action === PLAYER_ACTION.FOLD ||
                // buttonLoadingState?.action === PLAYER_ACTION.BET ||
                // buttonLoadingState?.action === PLAYER_ACTION.RAISE,
              })}
            >
              <PositionContext.Provider value={positionContextValue}>
                <ActionButtons
                  shouldSlideDownButtons={!shouldDisplayActionButton}
                  // setShouldSlideDownButtons={setShouldSlideDownButtons}
                  loadingAction={buttonLoadingState}
                  playAlInBGM={playMusicInGameRoom}
                  maxBet={maxBet}
                  availableActions={availableActions}
                  insuranceInfo={insuranceInfo}
                  insuranceExpireAt={insuranceExpireAt}
                  playerOrderInAction={playerInActionOrder}
                  myPlayerOrder={myPlayerOrder}
                  myPlayer={myPlayer}
                  smallBlind={basicBet}
                  pot={potValue}
                  minBet={minBet}
                  autoAction={myAutoAction}
                  shortcutOptions={shortcutOptions}
                  callAmount={callAmount}
                  gameMode={tableInfo?.gameType}
                  isAllIn={tableInfo?.isAllIn}
                  isDisableAllActions={isDisableAllActions}
                  actionKey={actionKey}
                  setTableActionCallback={setTableActionCallback}
                  setPlayerActionCallback={setPlayerActionCallback}
                />
              </PositionContext.Provider>
            </section>
          ) : null}
        </TournamentContext.Provider>

        {!myPlayer ? (
          <section className={classes.waitList}>
            <WaitList waitList={waitList} />
          </section>
        ) : null}
        <BuyInModalSheet // TODO: Refactor
          isBuyInLoading={isBuyInLoading}
          gameMode={tableInfo?.gameType}
          isAllIn={tableInfo?.isAllIn}
          currencyId={currencyId}
          smallBlind={smallBlind}
          bigBlind={bigBlind}
          open={isGameOverlayShown && isTableActive && isBuyInVisible}
          buyInMinAmount={minBuyIn}
          buyInMaxAmount={maxBuyInAmount}
          balance={walletBalance}
          expiredAt={buyInExpiredAt}
          onFinishCallback={buyInFinishCallback}
          onCancelCallback={buyInCancelCallback}
          closeDrawer={closeDrawer}
        />
        <TablePopup id={`sitOutModal_${tableIndex}`} visible={isSitOutModalVisible}>
          <img
            src="/images-mobile/game-room/GameRoom/clock.webp"
            srcSet="/images-mobile/game-room/GameRoom/clock@2x.webp"
            alt="clock"
            className={classes.clockImage}
          />
          {/* <Countdown
            valueStyle={{
              color: 'white',
              fontSize: 32,
              fontFamily: 'Avenir Next Condensed',
              fontWeight: 'bold',
            }}
            value={forceQuitMoment}
            format="mm:ss"
          /> */}
          <Countdown
            date={dayjs(forceQuitMoment).toDate()}
            renderer={({minutes, seconds}) => countdownRenderer({minutes, seconds, isLarge: true})}
          />
          <GradientButton
            id="sitInButton"
            style={{margin: 0, marginTop: 10, width: 'fit-content'}}
            className={classes.rejoinRoomButton}
            onClick={() => {
              const data = {
                action: TABLE_ACTIONS.SIT_IN,
              };
              try {
                socket?.call(GAME_EVENTS_V3.EM_PLAYER_SET_TABLE_ACTION, {
                  roomCode: roomNumber,
                  data,
                });
                setIsSitOutModalVisible(false);
              } catch {
                console.log('set table action failed');
              }
            }}
          >
            {t('rejoin_room')}
          </GradientButton>
        </TablePopup>
        {isTournament && (
          <TablePopup
            id={`tournament_table_balancing_${tableIndex}`}
            visible={isTournamentTableBalancingModalVisible}
          >
            <div>Tournament Table Balancing</div>
            <img
              src="/images-mobile/game-room/GameRoom/clock.webp"
              srcSet="/images-mobile/game-room/GameRoom/clock@2x.webp"
              alt="clock"
              className={classes.clockImage}
            />
            <div>{t('tournament_table_balancing_msg')}</div>
          </TablePopup>
        )}
        <div
          id={`rejoinModal_${tableIndex}`}
          className={classNames(
            classes.forceQuitModal,
            !isWithdrawExtraBetVisible && classes.hidden
          )}
        >
          <img src="/images-mobile/game-room/coin.svg" alt="coin" className={classes.clockImage} />
          <span className={classes.modalTitle}>{t('confirm_withdraw_extra_bet_msg')}</span>
          <GradientButton
            className={classes.rejoinRoomButton}
            onClick={async () => {
              withdrawExtraBet();
            }}
          >
            {t('yes')}
          </GradientButton>
          <GradientButton
            className={classes.rejoinRoomButton}
            onClick={() => {
              setIsWithdrawExtraBetVisible(false);
            }}
          >
            {t('no')}
          </GradientButton>
        </div>
        <BuyInModalSheet
          // isBuyInLoading={isBuyInLoading}
          gameMode={tableInfo?.gameType}
          isAllIn={tableInfo?.isAllIn}
          zIndex={1}
          currencyId={currencyId}
          expiredAt={null}
          smallBlind={smallBlind}
          bigBlind={bigBlind}
          open={isGameOverlayShown && isTableActive && isAddExtraBetVisible}
          buyInMinAmount={calculateBuyInMinAmount()}
          buyInMaxAmount={calculateBuyInMaxAmount(maxBuyIn, getPlayerCurrentMoney(myPlayer))}
          onFinishCallback={addExtraBet}
          // TODO balance should be retrieved from API or WS in the future
          balance={user.getCoinWalletBalance()}
          closeDrawer={closeExtraBetDrawer}
          // TODO fix warning
          onCancelCallback={closeExtraBetDrawer}
        />
        <div
          id={`afkModal_${tableIndex}`}
          className={classNames(classes.forceQuitModal, !isForceQuitModalVisible && classes.hidden)}
        >
          <img
            src="/images-mobile/game-room/GameRoom/clock.webp"
            srcSet="/images-mobile/game-room/GameRoom/clock@2x.webp"
            alt="clock"
            className={classes.clockImage}
          />
          <p className={classes.afkMessage}>{t('afk_timer_text')}</p>
          {/* <Countdown
            valueStyle={{
              color: 'white',
              fontSize: 32,
              fontFamily: 'Avenir Next Condensed',
              fontWeight: 'bold',
            }}
            value={forceQuitMoment}
            format="mm:ss"
          /> */}
          <Countdown
            date={dayjs(forceQuitMoment).toDate()}
            renderer={({minutes, seconds}) => countdownRenderer({minutes, seconds, isLarge: true})}
          />
          <GradientButton
            id="rejoinButton"
            className={classes.rejoinRoomButton}
            style={{borderRadius: 10, width: 'fit-content', margin: 0, marginTop: 10}}
            onClick={onRejoinRoom}
          >
            {t('rejoin_room')}
          </GradientButton>
        </div>

        <div
          className={classNames(
            classes.extendTimerModal,
            !isRoomMasterTimeSpanVisibile && classes.hidden
          )}
          id={`extendTimeModal_${tableIndex}`}
        >
          <ExtendTimer
            ref={extendTimerRef}
            encryptionKey={encryptionKey}
            roomNumber={tableInfo?.roomCode}
            expiredAt={privateRoomExpireTime || expiredTime}
            visible={isExtendRoomModalVisbile}
          />
        </div>

        {/* Tournament Waiting Timer - Disabled, using table text instead */}

        <div className={classNames(classes.remainTimeDiv, !isTimeSpanVisibile && classes.hidden)}>
          <ClockCircleOutlined color="white" style={{fontSize: '15px', marginRight: '5px'}} />
          {/* <Countdown
            valueStyle={{
              color: 'white',
              fontSize: 15,
              fontFamily: 'Avenir Next Condensed',
              fontWeight: 'bold',
            }}
            value={privateRoomExpireTime}
            format="mm:ss"
          /> */}
          <Countdown
            date={dayjs(privateRoomExpireTime).toDate()}
            renderer={({minutes, seconds}) => countdownRenderer({minutes, seconds, isLarge: false})}
          />
        </div>

        {/* <div
        className={classNames(
          classes.roomExpiredModal,
          !isExpiredRoomModalVisbile && classes.hidden
        )}
      >
        <img
          src="/images-mobile/game-room/GameRoom/clock.webp"
          srcSet="/images-mobile/game-room/GameRoom/clock@2x.webp"
          alt="clock"
          className={classes.clockImage}
        />
        <div>Time is UP! </div>
        <MainThemeButton
          className={classes.rejoinRoomButton}
          onClick={() => {
            Router.push(`/home`);
          }}
        >
          {t('back_to_home')}
        </MainThemeButton>
      </div> */}

        <EmojiContext.Provider value={emojiContextValue}>
          <EmojiDrawer
            roomNumber={roomNumber}
            open={isEmojiDrawerVisible}
            closeDrawer={closeEmojiDrawer}
            emojiList={emojiList}
            playerItemList={itemList}
            isEmojiListLoading={getLoading}
          />
        </EmojiContext.Provider>
        <HistoryDrawer
          roomNumber={roomNumber}
          open={isHistoryDrawerVisible}
          closeDrawer={closeHistoryDrawer}
        />

        {/* // TODO full-screen loading  */}
        <AnimatePresence>
          {(isTableActive && isLoadingGameState && !isDebugView) || isReturnedToBrowser ? (
            <motion.div
              key="loading-screen"
              initial={{opacity: 0}}
              animate={{opacity: 1}}
              exit={{opacity: 0}}
              transition={{duration: 0.5}}
              className={classes.fullScreenLoading}
            >
              <div style={{margin: 15}}>
                <Loading3QuartersOutlined spin style={{color: theme.textColor, fontSize: 25}} />
              </div>
              {t('loading_room_data')}
              {/* {roomNumber} */}
            </motion.div>
          ) : null}
        </AnimatePresence>
      </div>

      <CustomModalSheet
        isModalSheetOpen={isDebugPrintVisible}
        onModalSheetClose={() => {
          setIsDebugPrintVisible(false);
        }}
      >
        <Descriptions
          contentStyle={{whiteSpace: 'pre'}}
          bordered
          title="Custom Size"
          size="small"
          column={1}
          labelStyle={{color: 'white'}}
          extra={
            <Button onClick={handleCopyClick} type="primary">
              Copy
            </Button>
          }
          items={debugPrintItems}
        />
      </CustomModalSheet>

      <CustomPopup
        onCancel={() => {
          setIsJoinRoomErrorVisible(false);
        }}
        open={isCurrentTableInView && isJoinRoomErrorVisible}
        width={300}
        title={t('game_room:join_room_error_title')}
        buttons={[
          {
            isBlue: true,
            buttonFunction: async () => {
              setIsJoinRoomErrorVisible(false);
              user?.refreshJoinedRoom();
              // Callback is handled in another WS subscription
            },
            buttonLabel: t('common:retry'),
          },
          {
            isBlue: false,
            buttonFunction: () => {
              setIsJoinRoomErrorVisible(false);
              // Prevent popup re-appear after failing
            },
            buttonLabel: t('common:cancel'),
          },
        ]}
      >
        <div style={{textAlign: 'center'}}>
          {t('game_room:join_room_error_msg')}
          {joinRoomErrorCode && <p>{t(`errorCodes:${joinRoomErrorCode}`)}</p>}
        </div>
      </CustomPopup>

      {isTournament && (
        <>
          <TournamentReEntryModalSheet
            roomCode={roomNumber}
            isModalSheetOpen={isTournamentReEntryModalOpen && isCurrentTableInView && !!roomNumber}
            onModalSheetClose={() => {
              setIsTournamentReEntryModalOpen(false);
            }}
            tournamentId={tournamentId}
            tournamentName={tournamentResult?.tournamentName}
            tournamentTicketFee={tournamentRebuyInviteData?.tournamentTicketFee}
          />
          <TournamentResultModalSheet
            isModalSheetOpen={isTournamentResultModalOpen && isCurrentTableInView && !!roomNumber}
            onModalSheetClose={() => {
              setIsTournamentResultModalOpen(false);
            }}
            tournamentId={tournamentId}
            tournamentName={tournamentResult?.tournamentName}
            result={tournamentResult?.result}
          />
          <TournamentThanksForJoiningModalSheet
            isModalSheetOpen={isTournamentThanksForJoiningModalOpen && isCurrentTableInView && !!roomNumber}
            onModalSheetClose={() => {
              setIsTournamentThanksForJoiningModalOpen(false);
            }}
            tournamentId={tournamentThanksData?.tournamentId || tournamentId}
            tournamentName={tournamentThanksData?.tournamentName || tournamentResult?.tournamentName}
          />
          <TournamentWaitingForPlayersModalSheet
            isModalSheetOpen={isTournamentWaitingForPlayersModalOpen && isCurrentTableInView && !!roomNumber}
            onModalSheetClose={() => {
              setIsTournamentWaitingForPlayersModalOpen(false);
            }}
            tournamentName={tournamentWaitingData?.tournamentName || tournamentResult?.tournamentName}
            currentPlayers={tournamentWaitingData?.currentPlayers || 0}
            minPlayersRequired={tournamentWaitingData?.minPlayersRequired || 0}
          />

          <CustomPopup
            onCancel={() => {
              setIsSitOutTournamentWarningVisible(false);
            }}
            open={isCurrentTableInView && isSitOutTournamentWarningVisible}
            width={300}
            title={t('game_room:sit_out_tournament_warning.title')}
            buttons={[
              {
                isBlue: true,
                buttonFunction: async () => {
                  setIsSitOutTournamentWarningVisible(false);
                  // Callback is handled in another WS subscription
                },
                buttonLabel: t('common:cancel'),
              },
              {
                isBlue: false,
                buttonFunction: () => {
                  setIsSitOutTournamentWarningVisible(false);
                  fireTableAction('SIT_OUT');
                  // Prevent popup re-appear after failing
                },
                buttonLabel: t('game_room:leave_seat'),
              },
            ]}
          >
            {t('game_room:sit_out_tournament_warning.msg')}
          </CustomPopup>
        </>
      )}
      
      {/* Tournament Cancel Modal - Outside isTournament check since table might not be tournament type when cancelled */}
      <TournamentCancelModalSheet
        isModalSheetOpen={isTournamentCancelModalOpen}
        onModalSheetClose={() => {
          setIsTournamentCancelModalOpen(false);
        }}
        tournamentName={tournamentCancelData?.tournamentName || tournamentResult?.tournamentName}
        refundAmount={tournamentCancelData?.refundAmount}
      />
    </div>
  );
});

GameRoom.displayName = 'GameRoom';

export default React.memo(GameRoom);
